/* Sun Moon Rising V2 engine — faithful runtime for the design markup.
   Live adaptations: theme header/footer replace the design's own, the demo
   sign math is replaced by the page's proven astronomy engine (Astronomy
   Engine asset + Open-Meteo geocoding + historical time zones + a verified
   ascendant formula), the demo
   city list becomes live geocoding, the synthesis upgrades to an audited
   DeepSeek paragraph from /api/sun-moon-rising, sign card art uses the
   theme's celestial guardian set, and checkout runs on the proven shared
   rail (type "Sun Moon Rising (Big 3)", a canonical Big Three intent and
   the astrology-family signal labels). Rising is never guessed. */
(function () {
  'use strict';
  if (!document.querySelector('[data-rs2]')) return;

  var PAGE = '/pages/sun-moon-rising-calculator';
  var API_BASE = 'https://reading.deckaura.com/api/sun-moon-rising';
  var KEY = 'deckaura.smr.v2';
  var BIG_THREE_FUNNEL = 'big-three-synthesis-checkout-2026-08-v1';
  var BIG_THREE_SNAPSHOT = 'big-three-snapshot-v1';
  var RAIL_TIERS = { pattern: 'deeper', blueprint: 'indepth' };
  var SAVE_TTL = 30 * 24 * 60 * 60 * 1000;
  var UI_LANG = String(document.documentElement.lang || 'en').toLowerCase().split('-')[0];
  var I18N = window.RS2_I18N || { msg: function (key, vars, fallback) { return fallback || key; }, translate: function (value) { return value; }, sign: function (value) { return value; }, element: function (value) { return value; }, apply: function () {} };
  var CLOCK_24 = document.querySelector('[data-rs2]') && document.querySelector('[data-rs2]').getAttribute('data-rs2-clock') === '24';
  function tr(key, vars, fallback) { return I18N.msg(key, vars || {}, fallback || ''); }
  function tx(value) { return I18N.translate(String(value == null ? '' : value)); }
  function localSign(value) { return I18N.sign(value); }
  function localElement(value) { return I18N.element(value); }
  var UI_COPY = {
    en: {
      risingRole: 'Rising · first impression', risingMissing: 'We never guess the Ascendant. Add your birth time and your Rising calculates in seconds. Tap to add it.', editBirthTime: 'Add your birth time to calculate the Ascendant.',
      nonexistentLocalTime: 'That birth time did not exist at this birthplace because the clocks moved forward. Check the recorded time or choose “I don’t know” so we do not guess.',
      ambiguousLocalTime: 'That birth time happened twice when the clocks moved back. Without the recorded UTC offset we cannot safely choose one. Choose “I don’t know” so we do not guess.',
      nonexistentLocalDate: 'That local calendar date did not exist at the selected birthplace. Check the birth date and city.',
      priceChecking: 'Checking your local price…', priceUnavailable: 'Local prices are temporarily unavailable.', retryPrices: 'Retry prices',
      priceChanged: 'Price updated to {price}. Tap this package again to confirm.',
      priceUnavailableHelp: 'We could not confirm your local price. Retry before checkout.', readingsFrom: 'Readings from {min} to {max}',
      focusedAction: 'Answer My Question', patternAction: 'Map My Pattern', blueprintAction: 'Build My Blueprint',
      openingCheckout: 'Opening secure checkout…', preparingCheckout: 'Preparing your secure checkout…'
    },
    es: {
      risingRole: 'Ascendente · primera impresión', risingMissing: 'Nunca adivinamos el Ascendente. Añade tu hora de nacimiento y lo calcularemos en segundos. Toca para añadirla.', editBirthTime: 'Añade tu hora de nacimiento para calcular el Ascendente.',
      nonexistentLocalTime: 'Esa hora de nacimiento no existió en este lugar porque el reloj se adelantó. Comprueba la hora registrada o elige “No lo sé” para que no hagamos suposiciones.',
      ambiguousLocalTime: 'Esa hora ocurrió dos veces cuando el reloj se atrasó. Sin el desfase UTC registrado no podemos elegir una de forma segura. Elige “No lo sé” para que no hagamos suposiciones.',
      nonexistentLocalDate: 'Esa fecha local no existió en el lugar de nacimiento seleccionado. Comprueba la fecha y la ciudad.',
      priceChecking: 'Comprobando tu precio local…', priceUnavailable: 'Los precios locales no están disponibles temporalmente.', retryPrices: 'Reintentar precios',
      priceChanged: 'El precio se actualizó a {price}. Toca de nuevo este paquete para confirmarlo.',
      priceUnavailableHelp: 'No pudimos confirmar tu precio local. Vuelve a intentarlo antes de pagar.', readingsFrom: 'Lecturas de {min} a {max}',
      focusedAction: 'Responder mi pregunta', patternAction: 'Trazar mi patrón', blueprintAction: 'Crear mi plan',
      openingCheckout: 'Abriendo el pago seguro…', preparingCheckout: 'Preparando tu pago seguro…'
    },
    de: {
      risingRole: 'Aszendent · erster Eindruck', risingMissing: 'Wir raten den Aszendenten nie. Ergänze deine Geburtszeit und er wird in Sekunden berechnet. Tippe hier, um sie einzugeben.', editBirthTime: 'Ergänze deine Geburtszeit, um den Aszendenten zu berechnen.',
      nonexistentLocalTime: 'Diese Geburtszeit gab es an diesem Ort wegen der Zeitumstellung nach vorn nicht. Prüfe die eingetragene Zeit oder wähle „Ich weiß es nicht“, damit wir nicht raten.',
      ambiguousLocalTime: 'Diese Uhrzeit trat bei der Zeitumstellung zurück zweimal auf. Ohne den eingetragenen UTC-Versatz können wir keine sichere Auswahl treffen. Wähle „Ich weiß es nicht“, damit wir nicht raten.',
      nonexistentLocalDate: 'Dieses lokale Kalenderdatum gab es am gewählten Geburtsort nicht. Prüfe Geburtsdatum und Ort.',
      priceChecking: 'Dein lokaler Preis wird geprüft…', priceUnavailable: 'Lokale Preise sind vorübergehend nicht verfügbar.', retryPrices: 'Preise erneut laden',
      priceChanged: 'Der Preis wurde auf {price} aktualisiert. Tippe zur Bestätigung erneut auf dieses Paket.',
      priceUnavailableHelp: 'Dein lokaler Preis konnte nicht bestätigt werden. Lade ihn vor dem Checkout erneut.', readingsFrom: 'Readings von {min} bis {max}',
      focusedAction: 'Meine Frage beantworten', patternAction: 'Mein Muster erkennen', blueprintAction: 'Meinen Plan erstellen',
      openingCheckout: 'Sicherer Checkout wird geöffnet…', preparingCheckout: 'Sicherer Checkout wird vorbereitet…'
    },
    pt: {
      risingRole: 'Ascendente · primeira impressão', risingMissing: 'Nunca adivinhamos o Ascendente. Indique a sua hora de nascimento e calculamo-lo em segundos. Toque para a adicionar.', editBirthTime: 'Indique a hora de nascimento para calcular o Ascendente.',
      nonexistentLocalTime: 'Essa hora de nascimento não existiu nesse local porque os relógios avançaram. Confirme a hora registada ou escolha “Não sei” para não fazermos suposições.',
      ambiguousLocalTime: 'Essa hora aconteceu duas vezes quando os relógios atrasaram. Sem o desvio UTC registado não podemos escolher uma com segurança. Escolha “Não sei” para não fazermos suposições.',
      nonexistentLocalDate: 'Essa data local não existiu no local de nascimento selecionado. Confirme a data e a cidade.',
      priceChecking: 'A confirmar o seu preço local…', priceUnavailable: 'Os preços locais estão temporariamente indisponíveis.', retryPrices: 'Tentar preços novamente',
      priceChanged: 'O preço foi atualizado para {price}. Toque novamente neste pacote para confirmar.',
      priceUnavailableHelp: 'Não foi possível confirmar o seu preço local. Tente novamente antes do checkout.', readingsFrom: 'Leituras de {min} a {max}',
      focusedAction: 'Responder à minha pergunta', patternAction: 'Mapear o meu padrão', blueprintAction: 'Criar o meu plano',
      openingCheckout: 'A abrir o checkout seguro…', preparingCheckout: 'A preparar o checkout seguro…'
    },
    tr: {
      risingRole: 'Yükselen · ilk izlenim', risingMissing: 'Yükselen burcu asla tahmin etmeyiz. Doğum saatinizi eklediğinizde saniyeler içinde hesaplarız. Eklemek için dokunun.', editBirthTime: 'Yükseleni hesaplamak için doğum saatinizi ekleyin.',
      nonexistentLocalTime: 'Bu doğum saati, doğum yerinizde saatler ileri alındığı için hiç yaşanmadı. Kayıttaki saati kontrol edin veya tahmin etmememiz için “Bilmiyorum” seçeneğini seçin.',
      ambiguousLocalTime: 'Bu doğum saati, saatler geri alındığında iki kez yaşandı. Kayıtlı UTC farkı olmadan güvenle seçim yapamayız. Tahmin etmememiz için “Bilmiyorum” seçeneğini seçin.',
      nonexistentLocalDate: 'Bu yerel takvim tarihi seçilen doğum yerinde hiç yaşanmadı. Doğum tarihini ve şehri kontrol edin.',
      priceChecking: 'Yerel fiyatınız kontrol ediliyor…', priceUnavailable: 'Yerel fiyatlar geçici olarak kullanılamıyor.', retryPrices: 'Fiyatları yeniden dene',
      priceChanged: 'Fiyat {price} olarak güncellendi. Onaylamak için bu pakete tekrar dokunun.',
      priceUnavailableHelp: 'Yerel fiyatınız doğrulanamadı. Ödemeden önce yeniden deneyin.', readingsFrom: '{min} ile {max} arasında yorumlar',
      focusedAction: 'Sorumu Yanıtla', patternAction: 'Örüntümü Haritala', blueprintAction: 'Yol Haritamı Oluştur',
      openingCheckout: 'Güvenli ödeme açılıyor…', preparingCheckout: 'Güvenli ödemeniz hazırlanıyor…'
    }
  };
  function uiCopy(key) { return (UI_COPY[UI_LANG] || UI_COPY.en)[key] || UI_COPY.en[key] || ''; }
  function uiText(key, vars) {
    var text = uiCopy(key);
    Object.keys(vars || {}).forEach(function (name) { text = text.replace(new RegExp('\\{' + name + '\\}', 'g'), String(vars[name])); });
    return text;
  }

  /* ------------ design data (verbatim) ------------ */
  var SIGNS = [
    ['Aries', 'Fire', 'direct action and visible progress', 'space to react honestly and immediately', 'fast, forward and ready to start'],
    ['Taurus', 'Earth', 'steadiness and something you can build on', 'predictability and physical comfort', 'calm, grounded and unhurried'],
    ['Gemini', 'Air', 'movement, ideas and variety', 'to talk things through before you settle', 'quick, adaptable and mentally active'],
    ['Cancer', 'Water', 'closeness and something worth protecting', 'emotional safety and to be remembered', 'gentle, careful and quietly protective'],
    ['Leo', 'Fire', 'visibility and creative self-expression', 'warm recognition from the people who matter', 'warm, present and hard to overlook'],
    ['Virgo', 'Earth', 'usefulness and work done properly', 'order and a plan you can trust', 'measured, competent and slightly reserved'],
    ['Libra', 'Air', 'balance and decisions made together', 'harmony and to know where you stand', 'pleasant, considerate and easy to be around'],
    ['Scorpio', 'Water', 'depth and something that means everything', 'certainty before you let anyone close', 'controlled, observant and private'],
    ['Sagittarius', 'Fire', 'range and room to move', 'honesty over politeness, and an exit', 'open, candid and unbothered'],
    ['Capricorn', 'Earth', 'authority earned slowly', 'control and self-sufficiency', 'serious, capable and self-contained'],
    ['Aquarius', 'Air', 'independence and a better system', 'distance to process before you share', 'friendly, but hard to place'],
    ['Pisces', 'Water', 'meaning and imaginative freedom', 'softness and space to process what you absorb', 'soft, receptive and slightly elsewhere']
  ];
  var FOCI = [
    ['self', 'Understand Myself'],
    ['love', 'Love & Relationships'],
    ['work', 'Work Style & Motivation'],
    ['pattern', 'A Repeating Pattern'],
    ['change', 'Ready for Change'],
    ['theme', 'My Strongest Theme']
  ];
  var PROMISE = {
    self: 'See why you may not recognise yourself in your Sun sign, and what your Moon is actually asking for.',
    love: 'See what you need in love, what you show first, and where the two may be misunderstood.',
    work: 'See what motivates you, how you work under pressure and how others may read your professional style.',
    pattern: 'See the trigger, emotional need, protective response and outcome behind the loop.',
    change: 'See which part of you is ready to move, and which part keeps holding the old arrangement in place.',
    theme: 'See which of your three placements leads most of the time, and what that costs the other two.'
  };
  var FOCUS_BULLET = {
    self: { focused: 'Why you may not recognise yourself in your Sun sign', pattern: 'Which side of you takes over when the three disagree', blueprint: 'A whole-self synthesis you can use in daily decisions' },
    love: { focused: 'What you need in love vs. what you show first', pattern: 'The closeness loop you repeat with partners', blueprint: 'How to ask for closeness without dropping your guard' },
    work: { focused: 'How you are read professionally, and why', pattern: 'How you behave under pressure at work', blueprint: 'Visibility, communication and boundaries at work' },
    pattern: { focused: 'The single tension that starts the loop', pattern: 'Your full trigger → need → protection → outcome loop', blueprint: 'How to interrupt the loop while it is still small' },
    change: { focused: 'The part of you that is ready to move first', pattern: 'What keeps pulling you back to the old arrangement', blueprint: 'A 30-day sequence for the change you named' },
    theme: { focused: 'Which placement is leading right now', pattern: 'What it costs the other two when one leads', blueprint: 'How to let each placement lead where it is strongest' }
  };
  var XSELL = {
    self: ['Full Birth Chart Calculator', 'Your Big Three is three placements. The full chart adds the houses and the rest of the planets.', '/pages/birth-chart-calculator'],
    love: ['Zodiac Compatibility Calculator', 'When you have the other person’s birth details, this compares both charts side by side.', '/pages/zodiac-compatibility'],
    work: ['Career Tarot Reading', 'A three-card reading focused on the decision or direction you are weighing at work.', '/pages/career-tarot-reading'],
    pattern: ['Attachment Style Quiz', 'Goes underneath the loop, into how the protective habit shows up in close relationships.', '/pages/attachment-style-quiz'],
    change: ['Free Tarot Reading', 'A focused card draw for the change you named, with a written reading if you want one.', '/pages/free-tarot-reading'],
    theme: ['Full Birth Chart Calculator', 'Shows whether the placement that leads your Big Three leads the whole chart.', '/pages/birth-chart-calculator']
  };
  var QUICK = [
    'I don’t feel like my Sun sign',
    'People often misunderstand me',
    'I feel torn between two sides of myself',
    'I repeat the same relationship pattern',
    'I want to understand my work style',
    'I want to know what part of me should lead',
    'Something else'
  ];
  var DEFAULT_Q = {
    self: 'Why do different sides of me want different things?',
    love: 'What do I need in love, and what do I show first?',
    work: 'How do I operate and come across professionally?',
    pattern: 'What keeps happening in this pattern, and why?',
    change: 'What part of me is asking to grow right now?',
    theme: 'Which part of my Big Three leads most strongly?'
  };

  /* ------------ state ------------ */
  var s = {
    stage: 'input', step: 1, focus: 'self',
    month: '', day: '', year: '', dateErr: '',
    timeConf: null, hour: '', minute: '', mer: 'AM', timeError: '',
    placeQuery: '', place: null, placeTouched: false, placeErr: '',
    chart: null, calcPhase: 0,
    qPick: null, qText: '', pkg: null,
    card: 0, sample: 'pattern',
    server: null, fetching: false,
    shareCopied: false, drawer: false, sheet: false,
    readingId: '', live: '', checkoutBusy: false,
    pricing: { status: 'loading', source: '', checkoutAllowed: false, retryable: false, currency: '', errorCode: '', tiers: {} }
  };
  var t1 = 0, t2 = 0, t3 = 0, cityTimer = 0, cityToken = 0, railReadingId = '';
  var railTimer = 0, railDeadline = 0, railReloading = false, synthesisEpoch = 0, synthesisAbort = null;
  var modalReturnFocus = null, modalInert = [], modalOpen = false, modalBodyOverflow = '';
  var checkoutStatusOwner = '', checkoutStatusMessage = '';

  /* ------------ helpers ------------ */
  function $(sel) { return document.querySelector(sel); }
  function $all(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }
  function wide() { return window.innerWidth >= 900; }
  function mid() { return window.innerWidth >= 700; }
  function track(name, data) {
    try { if (typeof window.gtag === 'function') window.gtag('event', name, Object.assign({ page_funnel: 'rs2' }, data || {})); } catch (_) {}
    try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (_) {}
  }
  function visitorId() {
    var key = 'deckaura_visitor_v1';
    try {
      var existing = localStorage.getItem(key);
      if (existing && /^[a-zA-Z0-9_-]{16,96}$/.test(existing)) return existing;
      var bytes = new Uint8Array(18); crypto.getRandomValues(bytes);
      var next = 'v_' + Array.prototype.map.call(bytes, function (x2) { return x2.toString(16).padStart(2, '0'); }).join('');
      localStorage.setItem(key, next);
      return next;
    } catch (_) { return 'v_' + Date.now().toString(16) + Math.random().toString(36).slice(2, 10); }
  }
  function live(msg) {
    s.live = msg;
    var el = $('[data-rs2-live]');
    if (el) el.textContent = msg;
  }
  function save() {
    try {
      localStorage.setItem(KEY, JSON.stringify({
        version: 3, savedAt: Date.now(), time24: validTime() ? canonicalBirthTime() : null,
        stage: s.stage === 'result' ? 'result' : 'input',
        focus: s.focus, month: s.month, day: s.day, year: s.year,
        timeConf: s.timeConf, hour: s.hour, minute: s.minute, mer: s.mer,
        place: s.place, qPick: s.qPick, qText: s.qText, pkg: s.pkg,
        readingId: s.readingId, clock24: CLOCK_24,
        server: s.server && s.server.key ? {
          key: s.server.key, synthesis: String(s.server.synthesis || '').slice(0, 1200),
          note: String(s.server.note || '').slice(0, 400), source: String(s.server.source || '').slice(0, 80)
        } : null
      }));
    } catch (_) {}
  }
  function signMeta(name) {
    for (var i = 0; i < SIGNS.length; i += 1) if (SIGNS[i][0] === name) return SIGNS[i];
    return null;
  }
  function focusLabel() {
    for (var i = 0; i < FOCI.length; i += 1) if (FOCI[i][0] === s.focus) return tx(FOCI[i][1]);
    return tx('Understand Myself');
  }
  function artUrl(sign) {
    var base = window.RS2_ART_BASE || '';
    return base.replace('__SIGN__', sign.toLowerCase());
  }

  /* ------------ astronomy engine (lifted verbatim from the live page) ------------ */
  function norm(v) { v %= 360; if (v < 0) v += 360; return v; }
  var TIMEZONE_FORMATTERS = Object.create(null);
  function timeZoneFormatter(tz) {
    if (TIMEZONE_FORMATTERS[tz]) return TIMEZONE_FORMATTERS[tz];
    try {
      TIMEZONE_FORMATTERS[tz] = new Intl.DateTimeFormat('en-CA', {
        timeZone: tz, calendar: 'gregory', numberingSystem: 'latn',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
      });
      return TIMEZONE_FORMATTERS[tz];
    } catch (_) { throw new Error('timezone'); }
  }
  function localPartsAt(tz, date) {
    var parts = timeZoneFormatter(tz).formatToParts(date), out = {};
    for (var i = 0; i < parts.length; i += 1) if (parts[i].type !== 'literal') out[parts[i].type] = parseInt(parts[i].value, 10);
    return out;
  }
  function sameLocal(parts, y, m, d, h, minute) {
    return parts.year === y && parts.month === m && parts.day === d && parts.hour === h && parts.minute === minute && parts.second === 0;
  }
  function offsetAtInstant(tz, millis) {
    var parts = localPartsAt(tz, new Date(millis));
    return Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second) - Math.floor(millis / 1000) * 1000;
  }
  function candidateOffsets(tz, wall) {
    var offsets = [];
    for (var hours = -48; hours <= 48; hours += 3) {
      var offset = offsetAtInstant(tz, wall + hours * 3600000);
      if (offsets.indexOf(offset) < 0) offsets.push(offset);
    }
    return offsets;
  }
  function localTimeCandidates(y, m, d, h, minute, tz, knownOffsets) {
    var wall = Date.UTC(y, m - 1, d, h, minute);
    var offsets = knownOffsets || candidateOffsets(tz, wall);
    var candidates = [];
    for (var i = 0; i < offsets.length; i += 1) {
      var date = new Date(wall - offsets[i]);
      if (sameLocal(localPartsAt(tz, date), y, m, d, h, minute) && !candidates.some(function (item) { return item.getTime() === date.getTime(); })) candidates.push(date);
    }
    candidates.sort(function (a, b) { return a - b; });
    return candidates;
  }
  function utcFromLocal(y, m, d, h, minute, tz) {
    var candidates = localTimeCandidates(y, m, d, h, minute, tz);
    if (!candidates.length) throw new Error('nonexistent_local_time');
    if (candidates.length > 1) throw new Error('ambiguous_local_time');
    return candidates[0];
  }
  function localDateBounds(y, m, d, tz) {
    var offsets = candidateOffsets(tz, Date.UTC(y, m - 1, d, 12, 0));
    var first = null, last = null;
    for (var startMinute = 0; startMinute < 1440 && !first; startMinute += 1) {
      var firstSet = localTimeCandidates(y, m, d, Math.floor(startMinute / 60), startMinute % 60, tz, offsets);
      if (firstSet.length) first = firstSet[0];
    }
    if (!first) throw new Error('nonexistent_local_date');
    for (var endMinute = 1439; endMinute >= 0 && !last; endMinute -= 1) {
      var lastSet = localTimeCandidates(y, m, d, Math.floor(endMinute / 60), endMinute % 60, tz, offsets);
      if (lastSet.length) last = lastSet[lastSet.length - 1];
    }
    if (!last) throw new Error('nonexistent_local_date');
    return { start: first, end: last };
  }
  function jd(date) { return date.getTime() / 86400000 + 2440587.5; }
  function getLon(value) { if (value == null) return null; if (value.elon != null) return value.elon; if (value.lon != null) return value.lon; return value.longitude; }
  function bodyLon(key, date) {
    var A = window.Astronomy;
    if (!A) throw new Error('engine');
    return key === 'Sun' ? norm(getLon(A.SunPosition(date))) : norm(getLon(A.EclipticGeoMoon(date)));
  }
  function signIndex(lon) { return Math.floor(norm(lon) / 30) % 12; }
  function signDegree(lon) { return norm(lon) % 30; }
  function formatDegree(lon) {
    var degree = Math.floor(signDegree(lon)), minute = Math.round((signDegree(lon) - degree) * 60);
    if (minute === 60) { degree++; minute = 0; }
    return degree + '° ' + (minute < 10 ? '0' : '') + minute + '′';
  }
  function ascendant(date, lat, lonEast) {
    var julian = jd(date), t = (julian - 2451545.0) / 36525,
      ramc = norm(window.Astronomy.SiderealTime(date) * 15 + lonEast) * Math.PI / 180,
      eps = (23.4392911 - 0.0130042 * t) * Math.PI / 180,
      phi = lat * Math.PI / 180;
    return norm(Math.atan2(Math.cos(ramc), -(Math.sin(ramc) * Math.cos(eps) + Math.tan(phi) * Math.sin(eps))) * 180 / Math.PI);
  }
  function hour24() {
    if (CLOCK_24) return parseInt(s.hour, 10);
    var h = parseInt(s.hour, 10) % 12;
    return s.mer === 'PM' ? h + 12 : h;
  }
  function validDate() {
    var y = Number(s.year), m = Number(s.month), d = Number(s.day);
    if (!/^\d{4}$/.test(s.year) || !/^\d{1,2}$/.test(s.month) || !/^\d{1,2}$/.test(s.day)) return false;
    var date = new Date(y, m - 1, d);
    return y >= 1900 && date.getFullYear() === y && date.getMonth() === m - 1 && date.getDate() === d && date <= new Date();
  }
  function validTime() {
    if (s.timeConf === 'unknown') return true;
    return /^(exact|approx)$/.test(s.timeConf) && /^\d{1,2}$/.test(s.hour) && /^\d{2}$/.test(s.minute)
      && Number(s.hour) >= (CLOCK_24 ? 0 : 1) && Number(s.hour) <= (CLOCK_24 ? 23 : 12)
      && Number(s.minute) <= 59 && /^(AM|PM)$/.test(s.mer);
  }
  function validPlace(place) {
    if (!place || typeof place.tz !== 'string' || !place.tz || !Number.isFinite(place.lat) || Math.abs(place.lat) > 90 || !Number.isFinite(place.lon) || Math.abs(place.lon) > 180) return false;
    try { timeZoneFormatter(place.tz); return true; } catch (_) { return false; }
  }
  function computeChart() {
    if (!validDate()) throw new Error('invalid_birth_date');
    if (!validTime()) throw new Error('invalid_birth_time');
    if (!validPlace(s.place)) throw new Error('timezone');
    var y = parseInt(s.year, 10), m = parseInt(s.month, 10), d = parseInt(s.day, 10);
    var status = s.timeConf;
    var hour = status === 'unknown' ? 12 : hour24();
    var minute = status === 'unknown' ? 0 : parseInt(s.minute, 10);
    var bounds = localDateBounds(y, m, d, s.place.tz);
    var birth = utcFromLocal(y, m, d, hour, minute, s.place.tz);
    var sunLon = bodyLon('Sun', birth);
    var moonLon = bodyLon('Moon', birth);
    var dayStart = bounds.start;
    var dayEnd = bounds.end;
    var moonStart = bodyLon('Moon', dayStart);
    var moonEnd = bodyLon('Moon', dayEnd);
    var sunStart = bodyLon('Sun', dayStart);
    var sunEnd = bodyLon('Sun', dayEnd);
    var sunAmbiguous = status === 'unknown' && signIndex(sunStart) !== signIndex(sunEnd);
    var moonAmbiguous = status === 'unknown' && signIndex(moonStart) !== signIndex(moonEnd);
    var asc = status === 'unknown' ? null : ascendant(birth, s.place.lat, s.place.lon);
    return {
      status: status,
      sun: { lon: sunLon, sign: SIGNS[signIndex(sunLon)][0], ambiguous: sunAmbiguous, startLon: sunStart, endLon: sunEnd, startSign: SIGNS[signIndex(sunStart)][0], endSign: SIGNS[signIndex(sunEnd)][0] },
      moon: { lon: moonLon, sign: SIGNS[signIndex(moonLon)][0], ambiguous: moonAmbiguous, startLon: moonStart, endLon: moonEnd, startSign: SIGNS[signIndex(moonStart)][0], endSign: SIGNS[signIndex(moonEnd)][0] },
      asc: asc,
      rising: asc == null ? null : SIGNS[signIndex(asc)][0]
    };
  }
  function moonName(chart) {
    return chart.moon.ambiguous ? chart.moon.startSign + ' / ' + chart.moon.endSign : chart.moon.sign;
  }
  function sunName(chart) {
    return chart.sun.ambiguous ? chart.sun.startSign + ' / ' + chart.sun.endSign : chart.sun.sign;
  }
  function localPlacement(name) {
    return String(name || '').split(' / ').map(localSign).join(' / ');
  }
  function nearCusp(lon) {
    var degree = signDegree(lon);
    return degree <= 2 || degree >= 28;
  }
  function dominantElement(chart) {
    var counts = { Fire: 0, Earth: 0, Air: 0, Water: 0 };
    if (chart.sun.ambiguous) {
      counts[signMeta(chart.sun.startSign)[1]] += 0.5;
      counts[signMeta(chart.sun.endSign)[1]] += 0.5;
    } else counts[signMeta(chart.sun.sign)[1]]++;
    if (chart.moon.ambiguous) {
      counts[signMeta(chart.moon.startSign)[1]] += 0.5;
      counts[signMeta(chart.moon.endSign)[1]] += 0.5;
    } else counts[signMeta(chart.moon.sign)[1]]++;
    if (chart.rising) counts[signMeta(chart.rising)[1]]++;
    var winner = 'Fire', max = -1;
    for (var key in counts) if (counts[key] > max) { winner = key; max = counts[key]; }
    return winner;
  }

  /* ------------ city search (Open-Meteo, lifted from the live page) ------------ */
  function searchCity(query) {
    clearTimeout(cityTimer);
    var token = ++cityToken;
    renderPlaceResults([]);
    if (query.trim().length < 2) return;
    cityTimer = setTimeout(function () {
      fetch('https://geocoding-api.open-meteo.com/v1/search?count=10&language=' + encodeURIComponent(UI_LANG) + '&format=json&name=' + encodeURIComponent(query.trim()))
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (token !== cityToken) return;
          var results = (data && data.results ? data.results : []).filter(function (city) {
            return validPlace({ lat: Number(city.latitude), lon: Number(city.longitude), tz: city.timezone });
          }).sort(function (a, b) { return Number(b.population || 0) - Number(a.population || 0); }).slice(0, 7).map(function (city) {
            var region = city.admin1 || '';
            return {
              name: city.name, region: region, country: city.country || '',
              lat: +city.latitude, lon: +city.longitude, tz: city.timezone,
              label: city.name + (region ? ', ' + region : '') + (city.country ? ', ' + city.country : ''),
              meta: Math.abs(city.latitude).toFixed(4) + '° ' + (city.latitude >= 0 ? 'N' : 'S') + ' · ' + Math.abs(city.longitude).toFixed(4) + '° ' + (city.longitude >= 0 ? 'E' : 'W')
            };
          });
          renderPlaceResults(results);
        })
        .catch(function () {
          if (token !== cityToken) return;
          renderPlaceResults([]);
          var err = $('[data-rs2-placeerr]');
          if (err) { err.textContent = tr('cityUnavailable', {}, 'City search is temporarily unavailable. Please try again.'); err.style.display = 'block'; }
        });
    }, 280);
  }
  var lastResults = [];
  function renderPlaceResults(results) {
    lastResults = results;
    ['[data-rs2-placelist]', '[data-rs2-sheetlist]'].forEach(function (sel) {
      var list = $(sel);
      if (!list) return;
      while (list.firstChild) list.removeChild(list.firstChild);
      results.forEach(function (r, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('data-rs2-placepick', String(i));
        btn.setAttribute('role', 'option');
        btn.setAttribute('style', 'appearance:none;cursor:pointer;width:100%;text-align:left;background:transparent;border:0;border-radius:9px;padding:11px 12px;min-height:48px;display:flex;flex-direction:column;gap:2px');
        var a = document.createElement('span');
        a.setAttribute('style', 'font-size:15.5px;font-weight:600');
        a.textContent = r.label;
        var b = document.createElement('span');
        b.setAttribute('style', "font-family:ui-monospace,'SF Mono',Menlo,monospace;font-size:11.5px;color:#5C554A");
        b.textContent = r.meta + ' · ' + r.tz;
        btn.appendChild(a); btn.appendChild(b);
        list.appendChild(btn);
      });
    });
    var wrap = $('[data-rs2-placelistwrap]');
    if (wrap) wrap.style.display = (!s.place && results.length) ? 'block' : 'none';
    var none = $('[data-rs2-placenone]');
    if (none) none.style.display = (!s.place && s.placeTouched && s.placeQuery.trim().length >= 2 && !results.length) ? 'block' : 'none';
    var sheetEmpty = $('[data-rs2-sheetempty]');
    if (sheetEmpty) {
      sheetEmpty.style.display = results.length ? 'none' : 'block';
      sheetEmpty.textContent = s.placeQuery.trim().length < 2
        ? tr('typeTwoLetters', {}, 'Type at least two letters to search for your birthplace.')
        : tr('noMatch', {}, 'No match yet. Try a larger nearby city, or the country name.');
    }
    $all('[data-rs2-placequery],[data-rs2-sheetquery]').forEach(function (input) {
      input.setAttribute('aria-expanded', (!s.place && results.length) ? 'true' : 'false');
    });
  }
  function pickPlace(index) {
    var r = lastResults[index];
    if (!r) return;
    clearTimeout(cityTimer);
    cityTimer = 0;
    cityToken += 1;
    s.place = r;
    s.placeQuery = r.label;
    s.placeErr = '';
    s.timeError = '';
    s.sheet = false;
    renderPlaceResults([]);
    save();
    track('rs2_place', { tz: r.tz });
    renderWizard();
  }

  /* ------------ server synthesis ------------ */
  function serverKey() {
    var c = s.chart;
    return c ? sunName(c) + '|' + moonName(c) + '|' + (c.rising || 'none') + '|' + (s.focus || 'self') + '|' + UI_LANG : '';
  }
  function localSynthesis() {
    var c = s.chart;
    if (!c) return { synthesis: '', note: '' };
    var sun = signMeta(c.sun.ambiguous ? c.sun.startSign : c.sun.sign);
    var moon = signMeta(c.moon.ambiguous ? c.moon.startSign : c.moon.sign);
    var rising = c.rising ? signMeta(c.rising) : null;
    var first = c.sun.ambiguous
      ? tr('fallbackSunAmbiguous', { a: localSign(c.sun.startSign), b: localSign(c.sun.endSign) }, 'Without a birth time, your Sun may be {a} or {b} because it changed signs that day.')
      : tr('fallbackSun', { need: tx(sun[2]) }, 'At your core you seek {need}.');
    var second = c.moon.ambiguous
      ? tr('fallbackMoonAmbiguous', { a: localSign(c.moon.startSign), b: localSign(c.moon.endSign) }, 'Emotionally, either {a} or {b} may describe your needs because the Moon changed signs that day.')
      : tr('fallbackMoon', { need: tx(moon[3]) }, 'Emotionally, you need {need}.');
    var third = rising
      ? tr('fallbackRising', { style: tx(rising[4]) }, 'People may first experience you as {style}.')
      : tr('fallbackNoRising', {}, 'How you come across is the part we cannot confirm without your birth time.');
    return {
      synthesis: first + ' ' + second + ' ' + third,
      note: s.timeConf === 'unknown' ? tr('unknownScope', {}, 'Birth time unknown: this reading uses your Sun and Moon only. No Rising sign is inferred.') : tr('fallbackNote', {}, 'This standard synthesis describes the parts. Your personalized reading applies their pattern to your question.')
    };
  }
  function fetchSynthesis() {
    if (s.fetching || s.stage !== 'result' || !s.chart) return;
    var key = serverKey();
    if (s.server && s.server.key === key) return;
    if (UI_LANG !== 'en' || s.chart.sun.ambiguous) {
      var local = localSynthesis();
      s.server = { key: key, synthesis: local.synthesis, note: local.note, source: 'localized_standard' };
      save();
      renderSynthesis();
      enableRail();
      return;
    }
    s.fetching = true;
    var c = s.chart;
    var body = {
      sun: sunName(c),
      moon: moonName(c),
      timeConf: s.timeConf,
      focus: s.focus || 'self',
      locale: UI_LANG,
      visitorId: visitorId(),
      readingId: s.readingId
    };
    if (c.rising) body.rising = c.rising;
    var ac = typeof AbortController === 'function' ? new AbortController() : null;
    synthesisAbort = ac;
    var epoch = ++synthesisEpoch;
    var timer = ac ? setTimeout(function () { ac.abort(); }, 16000) : 0;
    fetch(API_BASE + '/insight', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body), signal: ac ? ac.signal : undefined
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, status: r.status, data: j }; }); })
      .then(function (res) {
        if (epoch !== synthesisEpoch || s.stage !== 'result' || key !== serverKey()) return;
        if (res.ok && res.data && res.data.synthesis) {
          s.server = { key: key, synthesis: res.data.synthesis, note: res.data.note || '', source: res.data.servedSource || '' };
          save();
          track('rs2_synthesis_served', { source: res.data.servedSource || '' });
        } else {
          if (res.status === 429 || (res.data && res.data.error === 'free_limit_reached')) {
            var fallback = localSynthesis();
            s.server = {
              key: key, synthesis: fallback.synthesis,
              note: tr('quotaNote', {}, 'Today’s live synthesis allowance is used; this is the standard summary.'),
              source: 'rate_limit_standard'
            };
            save();
          }
          track('rs2_synthesis_unavailable', { reason: (res.data && res.data.error) || 'error' });
        }
      })
      .catch(function () { track('rs2_synthesis_unavailable', { reason: 'network' }); })
      .finally(function () {
        if (timer) clearTimeout(timer);
        if (epoch !== synthesisEpoch) return;
        synthesisAbort = null;
        s.fetching = false;
        renderSynthesis();
        enableRail();
      });
  }
  function synthesisTexts() {
    if (s.server && s.server.key === serverKey()) return { synthesis: s.server.synthesis, note: s.server.source === 'localized_standard' ? localSynthesis().note : s.server.note };
    return localSynthesis();
  }

  /* ------------ checkout rail ------------ */
  function railQuestion() {
    var text = s.qText.trim();
    if (text) return text;
    return tx(DEFAULT_Q[s.focus || 'self']);
  }
  function validateQuestion() {
    var value = s.qText.trim(), message = '';
    if (value && Array.from(value).length < 6) message = tr('questionTooShort', {}, 'Please write at least 6 characters, or leave the question blank.');
    else if (value.length > 700) message = tr('questionTooLong', {}, 'Keep your question to 700 characters.');
    var input = $('[data-rs2-qtext]');
    if (input) input.setAttribute('aria-invalid', message ? 'true' : 'false');
    var error = $('[data-rs2-qerror]');
    if (error) { error.hidden = !message; error.textContent = message; }
    if (!message) return true;
    checkoutStatus(message, 'err');
    live(message);
    scrollToId('offer');
    if (input) input.focus({ preventScroll: true });
    return false;
  }
  function railSignals() {
    var c = s.chart;
    var out = 'Sun: ' + (c.sun.ambiguous
      ? c.sun.startSign + ' or ' + c.sun.endSign + ' (changed signs that day, no birth time)'
      : c.sun.sign + ' (' + signMeta(c.sun.sign)[1] + ') ' + formatDegree(c.sun.lon).replace('°', ' deg').replace('′', ' min'));
    out += '; Moon: ' + (c.moon.ambiguous
      ? c.moon.startSign + ' or ' + c.moon.endSign + ' (changed signs that day, no birth time)'
      : c.moon.sign + ' (' + signMeta(c.moon.sign)[1] + ') ' + formatDegree(c.moon.lon).replace('°', ' deg').replace('′', ' min'));
    out += '; Rising: ' + (c.rising
      ? c.rising + ' (' + signMeta(c.rising)[1] + ')' + (s.timeConf === 'approx' ? ', estimated from an approximate birth time' : ', exact birth time')
      : 'Not calculated (no birth time)');
    out += c.sun.ambiguous || c.moon.ambiguous ? '; Element balance is uncertain because a placement changed signs on this date.' : '; Dominant element: ' + dominantElement(c);
    out += '; Birth time: ' + (s.timeConf === 'exact' ? 'Exact' : s.timeConf === 'approx' ? 'Approximate' : 'Unknown');
    out += '; Focus: ' + focusLabel();
    return out;
  }
  function visibleBigThree() {
    var c = s.chart;
    if (!c) return '';
    return localPlacement(sunName(c)) + ' ' + tx('Sun') + ' · ' + localPlacement(moonName(c)) + ' ' + tx('Moon') + ' · ' + (c.rising ? localSign(c.rising) + ' ' + tx('Rising') : tx('Rising not calculated'));
  }
  function railContext() {
    var base = 'Sun Moon Rising V3. ' + railSignals() + '.';
    function quoted(label, bodyText, cap) {
      var room = 2900 - base.length - label.length - 2;
      if (room < 40) return '';
      return label + '"' + bodyText.slice(0, Math.min(cap, room)) + '"';
    }
    var q = s.qText.trim();
    if (q) base += quoted(' Customer question, their own words: ', q, 700) || '';
    var syn = synthesisTexts();
    if (syn.synthesis) base += quoted(' Free synthesis already shown: ', syn.synthesis, 520) || '';
    if (s.place) base += ' Birthplace: ' + s.place.label + ' (' + s.place.tz + ').';
    return base;
  }
  function detailsProperty() {
    var parts = ['Focus: ' + focusLabel() + '.', 'Birth time: ' + (s.timeConf === 'exact' ? 'Exact' : s.timeConf === 'approx' ? 'Approximate (Rising estimated)' : 'Unknown (Rising not calculated; Sun-Moon reading)') + '.'];
    if (s.place) parts.push('Birthplace: ' + s.place.label + '.');
    var q = s.qText.trim();
    if (q) parts.push('Question: "' + q + '".');
    if (s.chart && s.chart.moon.ambiguous) parts.push('Moon note: changed signs that day (' + s.chart.moon.startSign + ' or ' + s.chart.moon.endSign + '); treat both as possible.');
    if (s.chart && s.chart.sun.ambiguous) parts.push('Sun note: changed signs that day (' + s.chart.sun.startSign + ' or ' + s.chart.sun.endSign + '); treat both as possible.');
    return parts.join(' ').slice(0, 1200);
  }
  function canonicalFocus() {
    return { work: 'career', change: 'current', theme: 'explore' }[s.focus] || s.focus || 'self';
  }
  function canonicalTimeStatus() {
    return s.timeConf === 'approx' ? 'approximate' : s.timeConf;
  }
  function pad2(value) { return String(value).padStart(2, '0'); }
  function canonicalBirthDate() {
    return String(s.year) + '-' + pad2(s.month) + '-' + pad2(s.day);
  }
  function canonicalBirthTime() {
    return canonicalTimeStatus() === 'unknown' ? null : pad2(hour24()) + ':' + pad2(s.minute);
  }
  function checkoutSnapshot() {
    var c = s.chart;
    return {
      version: BIG_THREE_SNAPSHOT,
      question: railQuestion(),
      focus: canonicalFocus(),
      birth: {
        date: canonicalBirthDate(),
        time: canonicalBirthTime(),
        status: canonicalTimeStatus(),
        place: {
          name: s.place.name,
          region: s.place.region || '',
          country: s.place.country || '',
          latitude: s.place.lat,
          longitude: s.place.lon,
          timezone: s.place.tz
        }
      },
      placements: {
        sun: { longitude: c.sun.lon, ambiguous: c.sun.ambiguous, startLongitude: c.sun.startLon, endLongitude: c.sun.endLon },
        moon: { longitude: c.moon.lon, ambiguous: c.moon.ambiguous, startLongitude: c.moon.startLon, endLongitude: c.moon.endLon },
        rising: c.asc == null ? null : { longitude: c.asc }
      }
    };
  }
  function blankPricing(status, errorCode) {
    return { status: status || 'loading', source: '', checkoutAllowed: false, retryable: status === 'error', currency: '', errorCode: errorCode || '', tiers: {} };
  }
  function normalizePricingSnapshot(snapshot) {
    var raw = snapshot && typeof snapshot === 'object' ? snapshot : {};
    var status = /^(?:loading|ready|fallback_ready|error)$/.test(String(raw.status || '')) ? String(raw.status) : 'error';
    if (status === 'loading') return blankPricing('loading', '');
    var currency = /^[A-Z]{3}$/.test(String(raw.currency || '').toUpperCase()) ? String(raw.currency).toUpperCase() : '';
    var normalized = {
      status: status,
      source: /^(?:live|liquid_retained|checkout)$/.test(String(raw.source || '')) ? String(raw.source) : '',
      checkoutAllowed: raw.checkout_allowed === true,
      retryable: raw.retryable === true,
      currency: currency,
      errorCode: String(raw.error_code || '').slice(0, 80),
      tiers: {}
    };
    (Array.isArray(raw.tiers) ? raw.tiers : []).forEach(function (item) {
      var tier = String(item && item.tier || '');
      if (!/^(?:essential|deeper|indepth)$/.test(tier)) return;
      var variantId = String(item.variant_id || '');
      var priceMinor = Number(item.price_minor);
      normalized.tiers[tier] = {
        tier: tier,
        variantId: /^\d{10,20}$/.test(variantId) ? variantId : '',
        priceMinor: Number.isInteger(priceMinor) && priceMinor > 0 ? priceMinor : null,
        formattedPrice: String(item.formatted_price || '').trim().slice(0, 80),
        available: item.available === true
      };
    });
    return normalized;
  }
  function pricingForPackage(pkgId) {
    return s.pricing.tiers[RAIL_TIERS[pkgId]] || null;
  }
  function packagePriceReady(pkgId) {
    var price = pricingForPackage(pkgId);
    return s.pricing.status === 'ready'
      && s.pricing.checkoutAllowed === true
      && /^[A-Z]{3}$/.test(s.pricing.currency)
      && !!price && price.available === true
      && /^\d{10,20}$/.test(price.variantId)
      && Number.isInteger(price.priceMinor) && price.priceMinor > 0
      && !!price.formattedPrice;
  }
  function canRetryPrices(pkgId) {
    return s.pricing.status === 'fallback_ready'
      || s.pricing.retryable === true
      || (s.pricing.status === 'ready' && !packagePriceReady(pkgId));
  }
  function applyPricingSnapshot(snapshot) {
    s.pricing = normalizePricingSnapshot(snapshot);
    if (s.stage === 'result') renderPackages();
    if (s.pricing.status === 'loading') checkoutStatus(uiCopy('priceChecking'), 'warn', 'pricing');
    else if (s.pricing.status === 'ready' && s.pricing.checkoutAllowed) checkoutStatus('', '', 'pricing');
    else checkoutStatus(uiCopy('priceUnavailableHelp'), 'err', 'pricing');
  }
  function syncPricingFromRail() {
    var api = window.DeckauraDeepReading;
    if (!api || typeof api.getPricingSnapshot !== 'function') {
      applyPricingSnapshot(blankPricing('error', 'pricing_api_unavailable'));
      return s.pricing;
    }
    try { applyPricingSnapshot(api.getPricingSnapshot()); }
    catch (_) { applyPricingSnapshot(blankPricing('error', 'pricing_snapshot_invalid')); }
    return s.pricing;
  }
  function retryMarketPrices(pkgId) {
    if (!railReadingId) {
      railDeadline = 0;
      if (!window.DeckauraDeepReading && !railReloading) {
        var original = $('script[src*="/rs2-checkout-runtime.js"]');
        if (original) {
          railReloading = true;
          var script = document.createElement('script');
          script.src = original.src; script.async = true;
          script.onload = function () { railReloading = false; enableRail(); };
          script.onerror = function () { railReloading = false; clearTimeout(railTimer); applyPricingSnapshot(blankPricing('error', 'pricing_runtime_unavailable')); };
          document.head.appendChild(script);
        }
      }
      applyPricingSnapshot(blankPricing('loading', '')); enableRail(); return true;
    }
    var api = window.DeckauraDeepReading;
    if (!api || typeof api.retryPricing !== 'function') {
      applyPricingSnapshot(blankPricing('error', 'pricing_retry_unavailable'));
      return false;
    }
    applyPricingSnapshot(blankPricing('loading', ''));
    live(uiCopy('priceChecking'));
    var started = false;
    try { started = api.retryPricing() === true; } catch (_) { started = false; }
    if (!started) {
      applyPricingSnapshot(blankPricing('error', 'pricing_retry_unavailable'));
      return false;
    }
    track('rs2_price_retry', { tier: RAIL_TIERS[pkgId] || '' });
    return true;
  }
  function checkoutQuoteMatches(meta) {
    var quote = meta && meta.quote;
    var tier = String(meta && meta.tier || '');
    var expected = s.pricing.tiers[tier];
    var expectedSku = { essential: 'READING-DEEP', deeper: 'READING-MEDIUM', indepth: 'READING-PREMIUM' }[tier] || '';
    return s.pricing.status === 'ready' && s.pricing.checkoutAllowed === true
      && !!expected && expected.available === true
      && !!quote
      && String(quote.variantId || '') === expected.variantId
      && String(meta.variantId || '') === expected.variantId
      && String(quote.sku || '').toUpperCase() === expectedSku
      && Number(quote.cents) === expected.priceMinor
      && String(quote.currency || '').toUpperCase() === s.pricing.currency
      && /^[A-Z]{2}$/.test(String(quote.country || '').toUpperCase())
      && !!String(quote.source || '')
      && Number.isInteger(Number(quote.requestId)) && Number(quote.requestId) > 0;
  }
  function checkoutIntent(meta) {
    if (!checkoutQuoteMatches(meta)) return {};
    var quote = meta.quote;
    var focus = canonicalFocus();
    var category = focus === 'love' ? 'love' : focus === 'career' ? 'career' : 'personal';
    return {
      endpoint: 'https://reading.deckaura.com/reading-intent',
      body: {
        kind: 'big_three',
        funnelVersion: BIG_THREE_FUNNEL,
        intent: focus,
        category: category,
        answer: 'CONDITIONAL',
        cardName: 'Big Three',
        displayedQuote: {
          variantId: String(quote.variantId),
          sku: String(quote.sku).toUpperCase(),
          priceCents: Number(quote.cents),
          currency: String(quote.currency).toUpperCase(),
          country: String(quote.country).toUpperCase()
        },
        snapshot: checkoutSnapshot()
      }
    };
  }
  function currentPkg() { return s.pkg; }
  function checkoutProperties(checkoutPackage) {
    var names = { pattern: 'Pattern Map', blueprint: 'Alignment Blueprint' };
    var packageByTier = { deeper: 'pattern', indepth: 'blueprint' };
    var pkgId = packageByTier[String(checkoutPackage && checkoutPackage.tier || '')] || currentPkg() || 'pattern';
    return {
      '_Presentation Variant': 'sun-moon-rising-v3',
      '_Page Design': 'sun-moon-rising-v3',
      '_Reading Title': names[pkgId],
      '_Details': detailsProperty(),
      '_Big Three Focus': canonicalFocus(),
      '_Birth Time Status': canonicalTimeStatus(),
      'Reading package': tx(names[pkgId]),
      'Your Big Three': visibleBigThree()
    };
  }
  function railDynamicOptions(pkgId) {
    var names = { pattern: 'Pattern Map', blueprint: 'Alignment Blueprint' };
    return {
      question: railQuestion(), readingId: s.readingId,
      curiosityQuestion: '',
      focus: focusLabel(), fixedFocus: 'Big3 V2 - ' + (s.focus || 'self'),
      context: railContext(), signals: railSignals(), cards: railSignals(),
      spread: s.chart.rising ? 'Big Three: Sun, Moon and Rising placements' : 'Big Three: Sun and Moon placements, Rising unavailable',
      scope: names[pkgId] + ' reading from the calculated ' + (s.chart.rising ? 'Big Three placements' : 'Sun and Moon placements; the Rising sign was not calculated because no birth time was supplied') + ' for the ' + focusLabel().toLowerCase() + ' focus.',
      confidence: s.chart.rising
        ? 'Astronomy-based placements from birth date, ' + (s.timeConf === 'approx' ? 'an approximate time' : 'exact time') + ' and birthplace coordinates with the historical time zone.'
        : 'Astronomy-based Sun and Moon from the birth date and birthplace; the Rising sign is never guessed without a birth time.',
      tool: PAGE, presentationVariant: 'sun-moon-rising-v3', resultReady: true,
      checkoutProperties: checkoutProperties
    };
  }
  function enableRail() {
    var api = window.DeckauraDeepReading;
    if (s.stage !== 'result' || !s.chart || s.checkoutBusy) return;
    if (!api || typeof api.enable !== 'function') {
      if (!railDeadline) railDeadline = Date.now() + 12000;
      clearTimeout(railTimer);
      if (Date.now() < railDeadline) railTimer = setTimeout(enableRail, 150);
      else applyPricingSnapshot(blankPricing('error', 'pricing_runtime_timeout'));
      return;
    }
    clearTimeout(railTimer);
    railDeadline = 0;
    var pkgId = currentPkg() || 'pattern';
    var dynamic = railDynamicOptions(pkgId);
    try {
      if (railReadingId === s.readingId && typeof api.update === 'function') {
        api.update(dynamic);
      } else {
        applyPricingSnapshot(blankPricing('loading', ''));
        api.enable(Object.assign({}, dynamic, {
        type: 'Sun Moon Rising (Big 3)', teaser: false, resultReady: true,
        canonicalPage: PAGE, visitorId: visitorId(), lang: UI_LANG,
        checkoutIntent: checkoutIntent,
        onPricingStateChange: applyPricingSnapshot, defaultTier: 'deeper'
        }));
        railReadingId = s.readingId;
      }
      if (typeof api.setPreviewAuthorization === 'function') api.setPreviewAuthorization({ previewToken: '', transportFallback: false });
      if (typeof api.setCheckoutPending === 'function') api.setCheckoutPending(false);
      if (currentPkg() && typeof api.setTier === 'function') api.setTier(RAIL_TIERS[currentPkg()] || 'deeper');
      syncPricingFromRail();
    } catch (_) {
      railReadingId = '';
      applyPricingSnapshot(blankPricing('error', 'pricing_setup_failed'));
    }
  }
  function checkoutStatus(msg, tone, owner) {
    if (owner === 'pricing' && checkoutStatusOwner === 'checkout' && checkoutStatusMessage) return;
    checkoutStatusOwner = owner || 'checkout'; checkoutStatusMessage = msg || '';
    var el = $('[data-rs2-checkout-status]');
    if (!el) return;
    el.setAttribute('role', tone === 'err' ? 'alert' : 'status');
    el.setAttribute('aria-live', tone === 'err' ? 'assertive' : 'polite');
    if (!msg) { el.style.display = 'none'; return; }
    el.textContent = msg;
    el.style.display = 'block';
    el.style.color = tone === 'warn' ? '#8A6626' : '#7A2423';
  }
  function startCheckout(via) {
    if (s.checkoutBusy || !validateQuestion()) return;
    var pkgId = currentPkg();
    if (!pkgId) { checkoutStatus(tx('Choose a reading depth above first.'), 'warn'); return; }
    var api = window.DeckauraDeepReading;
    if (!api || typeof api.checkoutNow !== 'function') {
      checkoutStatus(uiCopy('priceUnavailableHelp'), 'err');
      return;
    }
    enableRail();
    syncPricingFromRail();
    if (!packagePriceReady(pkgId)) {
      checkoutStatus(canRetryPrices(pkgId) ? uiCopy('priceUnavailableHelp') : uiCopy('priceUnavailable'), 'err');
      if (canRetryPrices(pkgId)) retryMarketPrices(pkgId);
      return;
    }
    try { api.setTier(RAIL_TIERS[pkgId] || 'deeper'); } catch (_) {}
    syncPricingFromRail();
    var railReady = false;
    try { railReady = typeof api.isPriceReady === 'function' && api.isPriceReady() === true; } catch (_) { railReady = false; }
    if (!packagePriceReady(pkgId) || !railReady) {
      checkoutStatus(uiCopy('priceUnavailableHelp'), 'err');
      return;
    }
    track('rs2_checkout_started', { tier: RAIL_TIERS[pkgId], via: via || 'sticky', currency: s.pricing.currency });
    s.checkoutBusy = true;
    checkoutStatus(uiCopy('preparingCheckout'), 'warn');
    renderPackages();
    var card = $('[data-rs2-pkg="' + pkgId + '"]');
    if (card) card.classList.add('rs2-pk-busy');
    var outcome = null;
    var started = false;
    try {
      if (typeof api.checkoutNowAsync === 'function') {
        outcome = api.checkoutNowAsync();
        started = !!outcome && typeof outcome.then === 'function';
      } else started = api.checkoutNow() === true;
    } catch (_) { started = false; }
    if (!started) {
      if (card) card.classList.remove('rs2-pk-busy');
      s.checkoutBusy = false;
      checkoutStatus(uiCopy('priceUnavailableHelp'), 'err');
      renderPackages();
      return;
    }
    if (outcome) outcome.then(function (result) {
      syncPricingFromRail();
      if (card) card.classList.remove('rs2-pk-busy');
      s.checkoutBusy = false;
      var recovery = $('[data-rs2-checkout-recovery]');
      if (recovery) recovery.hidden = !result || !/^(reading_cart_conflict|cart_result_uncertain|navigation|checkout_guard_unavailable|checkout_navigation_busy)$/.test(result.reason || '');
      if (result && result.ok) checkoutStatus('');
      else if (result && result.reason === 'price_confirmation_required') {
        var refreshedPrice = pricingForPackage(pkgId);
        checkoutStatus(refreshedPrice && refreshedPrice.formattedPrice
          ? uiText('priceChanged', { price: refreshedPrice.formattedPrice })
          : uiCopy('priceUnavailableHelp'), refreshedPrice && refreshedPrice.formattedPrice ? 'warn' : 'err');
      } else checkoutStatus(result && result.message ? result.message : uiCopy('priceUnavailableHelp'), 'err');
      renderPackages();
    }, function () {
      syncPricingFromRail();
      if (card) card.classList.remove('rs2-pk-busy');
      s.checkoutBusy = false;
      checkoutStatus(uiCopy('priceUnavailableHelp'), 'err');
      renderPackages();
    });
  }

  /* ------------ renders ------------ */
  function renderWizard() {
    var intro = $('[data-rs2-intro]');
    if (intro) intro.style.display = s.stage === 'result' ? 'none' : 'block';
    var result = $('[data-rs2-result]');
    if (result) result.style.display = s.stage === 'result' ? 'block' : 'none';
    if (s.stage === 'result') { renderResult(); return; }
    var isCalc = s.stage === 'calc';
    renderSticky();
    for (var i = 1; i < 4; i += 1) {
      var pane = $('[data-rs2-step="' + i + '"]');
      if (pane) pane.style.display = (!isCalc && s.step === i) ? 'flex' : 'none';
    }
    var calcPane = $('[data-rs2-calc]');
    if (calcPane) calcPane.style.display = isCalc ? 'flex' : 'none';
    $all('[data-rs2-calcline]').forEach(function (line, i) {
      line.style.color = i === s.calcPhase ? '#7A2423' : '#A79C8B';
    });
    $all('[data-rs2-stepdot]').forEach(function (node, i) {
      node.style.borderColor = i < s.step ? '#7A2423' : 'rgba(25,23,20,0.28)';
      node.style.background = i < s.step - 1 ? '#7A2423' : i === s.step - 1 ? 'rgba(122,36,35,0.22)' : 'transparent';
    });
    $all('[data-rs2-stepline]').forEach(function (node, i) {
      node.style.background = i < s.step - 1 ? '#7A2423' : 'rgba(25,23,20,0.16)';
    });
    $all('[data-rs2-steplabel]').forEach(function (node, i) {
      node.style.color = i === s.step - 1 ? '#191714' : '#5C554A';
    });
    var counter = $('[data-rs2-stepcounter]');
    if (counter) counter.textContent = tr('stepLive', { step: s.step }, 'Step {step} of 3');
    var bar = $('[data-rs2-progress]');
    if (bar) bar.style.width = (s.step / 3 * 100) + '%';
    $all('[data-rs2-focus]').forEach(function (btn) {
      var on = btn.getAttribute('data-rs2-focus') === s.focus;
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
      btn.style.borderColor = on ? '#B58A47' : 'rgba(25,23,20,0.14)';
      btn.style.background = on ? 'rgba(181,138,71,0.12)' : '#FFFDF8';
      var tick = btn.querySelector('[data-rs2-focustick]');
      if (tick) tick.style.display = on ? 'flex' : 'none';
    });
    var focusNext = $('[data-rs2-step="0"] [data-rs2-act="next"]');
    if (focusNext) {
      focusNext.disabled = !s.focus;
      focusNext.setAttribute('aria-disabled', s.focus ? 'false' : 'true');
      focusNext.style.opacity = s.focus ? '1' : '0.48';
      focusNext.style.cursor = s.focus ? 'pointer' : 'not-allowed';
    }
    ['month', 'day', 'year', 'hour', 'minute'].forEach(function (k) {
      var el = $('[data-rs2-' + k + ']');
      if (el && el.value !== s[k]) el.value = s[k];
    });
    var dateErr = $('[data-rs2-dateerr]');
    if (dateErr) { dateErr.style.display = s.dateErr ? 'flex' : 'none'; var t = dateErr.querySelector('span:last-child'); if (t) t.textContent = s.dateErr; }
    var preview = $('[data-rs2-datepreview]');
    if (preview) {
      var ready = s.month && s.day && s.year;
      preview.style.display = ready ? 'block' : 'none';
      if (ready) preview.textContent = new Intl.DateTimeFormat(UI_LANG, { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(parseInt(s.year, 10), parseInt(s.month, 10) - 1, parseInt(s.day, 10)));
    }
    $all('[data-rs2-timeconf]').forEach(function (btn) {
      var on = btn.getAttribute('data-rs2-timeconf') === s.timeConf;
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
      btn.style.borderColor = on ? '#B58A47' : 'rgba(25,23,20,0.14)';
      btn.style.background = on ? 'rgba(181,138,71,0.12)' : '#FFFDF8';
      var ring = btn.querySelector('[data-rs2-timering]');
      if (ring) {
        ring.style.borderColor = on ? '#7A2423' : 'rgba(25,23,20,0.3)';
        var dot = ring.querySelector('span');
        if (dot) dot.style.background = on ? '#7A2423' : 'transparent';
      }
    });
    var timeFields = $('[data-rs2-timefields]');
    if (timeFields) timeFields.style.display = (s.timeConf === 'exact' || s.timeConf === 'approx') ? 'flex' : 'none';
    var timeNote = $('[data-rs2-timenote]');
    if (timeNote) {
      var notes = {
        approx: tr('approxNote', {}, 'Your Rising sign will be marked as estimated. A small time difference can change the result.'),
        unknown: tr('unknownNote', {}, 'That’s okay. Your Sun and Moon can still reveal a meaningful pattern. We will not guess your Rising sign.')
      };
      var note = s.timeError || (s.timeConf ? notes[s.timeConf] : '');
      timeNote.style.display = note ? 'block' : 'none';
      timeNote.textContent = note || '';
      timeNote.style.color = s.timeError ? '#7A2423' : '#28394A';
      timeNote.style.background = s.timeError ? 'rgba(122,36,35,0.07)' : 'rgba(49,72,92,0.07)';
      timeNote.style.border = s.timeError ? '1px solid rgba(122,36,35,0.24)' : '1px solid rgba(49,72,92,0.18)';
      if (s.timeError) {
        timeNote.setAttribute('role', 'alert');
        timeNote.setAttribute('aria-live', 'assertive');
        timeNote.setAttribute('data-rs2-timeerror', 'true');
      } else {
        timeNote.removeAttribute('role');
        timeNote.removeAttribute('aria-live');
        timeNote.removeAttribute('data-rs2-timeerror');
      }
    }
    var am = $('[data-rs2-am]'), pm = $('[data-rs2-pm]');
    if (am) { am.setAttribute('aria-checked', s.mer === 'AM' ? 'true' : 'false'); am.style.background = s.mer === 'AM' ? '#191714' : 'transparent'; am.style.color = s.mer === 'AM' ? '#FBF6EC' : '#191714'; }
    if (pm) { pm.setAttribute('aria-checked', s.mer === 'PM' ? 'true' : 'false'); pm.style.background = s.mer === 'PM' ? '#191714' : 'transparent'; pm.style.color = s.mer === 'PM' ? '#FBF6EC' : '#191714'; }
    var placeInput = $('[data-rs2-placequery]');
    if (placeInput && placeInput.value !== s.placeQuery) placeInput.value = s.placeQuery;
    var sheetInput = $('[data-rs2-sheetquery]');
    if (sheetInput && sheetInput.value !== s.placeQuery) sheetInput.value = s.placeQuery;
    var chosen = $('[data-rs2-placechosen]');
    if (chosen) {
      chosen.style.display = s.place ? 'block' : 'none';
      if (s.place) {
        var n = $('[data-rs2-placename]'); if (n) n.textContent = s.place.label;
        var cds = $('[data-rs2-placecoords]'); if (cds) cds.textContent = s.place.meta;
        var tz = $('[data-rs2-placetz]'); if (tz) tz.textContent = tr('timezoneMatched', { tz: s.place.tz }, 'Historical time zone matched · {tz}');
      }
    }
    var listwrap = $('[data-rs2-placelistwrap]');
    if (listwrap && s.place) listwrap.style.display = 'none';
    var perr = $('[data-rs2-placeerr]');
    if (perr) { perr.style.display = s.placeErr ? 'block' : 'none'; perr.textContent = s.placeErr; }
    var sheet = $('[data-rs2-sheet]');
    if (sheet) sheet.style.display = (s.sheet && !mid()) ? 'flex' : 'none';
  }
  function accuracyChips() {
    var unknown = s.timeConf === 'unknown';
    return [
      { label: s.timeConf === 'exact' ? tx('Exact birth time') : s.timeConf === 'approx' ? tx('Approximate birth time') : tx('No birth time provided'), color: s.timeConf === 'exact' ? '#7FA88A' : '#D8A45F' },
      { label: tx('Birthplace coordinates applied'), color: '#7FA88A' },
      { label: unknown ? tx('Rising unavailable without a birth time') : s.timeConf === 'approx' ? tx('Rising sign estimated') : tx('Historical time zone matched'), color: unknown || s.timeConf === 'approx' ? '#D8A45F' : '#7FA88A' }
    ];
  }
  function renderResult() {
    var c = s.chart;
    if (!c) return;
    var set = function (sel, value) { var el = $(sel); if (el) el.textContent = value; };
    set('[data-rs2-bigline]', visibleBigThree());
    var chips = $('[data-rs2-accuracy]');
    if (chips) {
      while (chips.firstChild) chips.removeChild(chips.firstChild);
      accuracyChips().forEach(function (a) {
        var span = document.createElement('span');
        span.setAttribute('style', 'display:flex;align-items:center;gap:9px;font-size:14.5px;color:#E4D6BC');
        var ring = document.createElement('span');
        ring.setAttribute('aria-hidden', 'true');
        ring.setAttribute('style', 'flex:none;width:16px;height:16px;border-radius:50%;border:1px solid ' + a.color + ';display:flex;align-items:center;justify-content:center');
        var dot = document.createElement('span');
        dot.setAttribute('style', 'display:block;width:6px;height:6px;border-radius:50%;background:' + a.color);
        ring.appendChild(dot);
        span.appendChild(ring);
        span.appendChild(document.createTextNode(a.label));
        chips.appendChild(span);
      });
    }
    var roles = [
      c.sun.ambiguous
        ? { key: 'sun', role: tx('Sun · core identity'), sign: localPlacement(sunName(c)), tag: tx('Changed signs that day'), meta: tx('Both core styles remain possible'), body: tr('sunCardAmbiguous', { a: localSign(c.sun.startSign), b: localSign(c.sun.endSign) }, 'Without a birth time, the Sun stays between {a} and {b}; both core styles remain possible.'), art: c.sun.startSign }
        : { key: 'sun', role: tx('Sun · core identity'), sign: localSign(c.sun.sign), tag: nearCusp(c.sun.lon) ? tx('Near sign cusp') : '', meta: localElement(signMeta(c.sun.sign)[1]) + ' · ' + formatDegree(c.sun.lon) + ' · ' + tx('what you are becoming'), body: tr('sunCard', { need: tx(signMeta(c.sun.sign)[2]) }, 'At your core you seek {need}.'), art: c.sun.sign },
      c.moon.ambiguous
        ? { key: 'moon', role: tx('Moon · emotional needs'), sign: localPlacement(moonName(c)), tag: tx('Changed signs that day'), meta: tx('Both emotional styles remain possible'), body: tr('moonCardAmbiguous', { a: localSign(c.moon.startSign), b: localSign(c.moon.endSign) }, 'Without a birth time, the Moon may be {a} or {b}; either emotional style may describe your needs.'), art: c.moon.startSign }
        : { key: 'moon', role: tx('Moon · emotional needs'), sign: localSign(c.moon.sign), tag: (nearCusp(c.moon.lon) ? tx('Near sign cusp') : (s.timeConf === 'unknown' ? tx('From your date') : '')), meta: localElement(signMeta(c.moon.sign)[1]) + ' · ' + formatDegree(c.moon.lon) + ' · ' + tx('what makes you feel safe'), body: tr('moonCard', { need: tx(signMeta(c.moon.sign)[3]) }, 'Emotionally you need {need}.'), art: c.moon.sign },
      c.rising
        ? { key: 'rising', role: tx('Rising · first impression'), sign: localSign(c.rising), tag: (s.timeConf === 'approx' ? tx('Estimated') + (nearCusp(c.asc) ? ' · ' + tx('Near sign cusp') : '') : (nearCusp(c.asc) ? tx('Near sign cusp') : '')), meta: localElement(signMeta(c.rising)[1]) + ' · ' + formatDegree(c.asc) + ' · ' + tx('how you meet the world'), body: s.timeConf === 'approx' ? tr('risingCardApprox', { style: tx(signMeta(c.rising)[4]) }, 'From an approximate time, people are likely to first experience you as {style}.') : tr('risingCard', { style: tx(signMeta(c.rising)[4]) }, 'People first experience you as {style}.'), art: c.rising }
        : { key: 'rising', role: uiCopy('risingRole'), sign: '', tag: '', meta: '', body: uiCopy('risingMissing'), art: null }
    ];
    roles.forEach(function (r) {
      var node = $('[data-rs2-card-' + r.key + ']');
      if (!node) return;
      if (r.key === 'rising') {
        if (r.art) {
          node.removeAttribute('role'); node.removeAttribute('tabindex'); node.removeAttribute('aria-label'); node.style.cursor = '';
        } else {
          node.setAttribute('role', 'button'); node.setAttribute('tabindex', '0'); node.setAttribute('aria-label', uiCopy('editBirthTime')); node.style.cursor = 'pointer';
        }
      }
      var img = node.querySelector('img');
      var placeholder = node.querySelector('[data-rs2-cardph]');
      if (r.art) {
        if (img) { img.style.display = 'block'; img.src = artUrl(r.art); img.alt = tr('cardAlt', { sign: localSign(r.art), role: tx(r.key) }, '{sign} celestial card for the calculated {role} sign'); }
        if (placeholder) placeholder.style.display = 'none';
      } else {
        // No calculated Rising: never show an unrelated deck back. Show a
        // themed Ascendant placeholder that matches the celestial cards.
        if (img) { img.style.display = 'none'; img.removeAttribute('src'); }
        if (placeholder) placeholder.style.display = 'flex';
      }
      var setIn = function (sel, value) { var el = node.querySelector(sel); if (el) el.textContent = value; };
      setIn('[data-rs2-csign]', r.sign);
      setIn('[data-rs2-cmeta]', r.meta);
      setIn('[data-rs2-cbody]', r.body);
      var signEl = node.querySelector('[data-rs2-csign]');
      if (signEl) signEl.style.display = r.sign ? '' : 'none';
      var metaEl = node.querySelector('[data-rs2-cmeta]');
      if (metaEl) metaEl.style.display = r.meta ? '' : 'none';
      var roleEls = node.querySelectorAll('[data-rs2-crole]');
      for (var ri = 0; ri < roleEls.length; ri += 1) roleEls[ri].textContent = r.role;
      // The on-image role caption (first crole) duplicates the Ascendant
      // placeholder when there is no art, so hide it in that case.
      if (roleEls[0]) roleEls[0].style.display = r.art ? '' : 'none';
      var tag = node.querySelector('[data-rs2-ctag]');
      if (tag) { tag.style.display = r.tag ? 'inline-block' : 'none'; tag.textContent = r.tag; }
    });
    renderCarousel();
    renderSynthesis();
    var shareMeta = $('[data-rs2-sharemeta]');
    if (shareMeta) {
      shareMeta.textContent = new Intl.DateTimeFormat(UI_LANG, { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(parseInt(s.year, 10), parseInt(s.month, 10) - 1, parseInt(s.day, 10)));
    }
    var rows = [[tx('Sun'), localPlacement(sunName(c))], [tx('Moon'), localPlacement(moonName(c))], [tx('Rising'), c.rising ? localSign(c.rising) : tx('Not calculated')]];
    $all('[data-rs2-sharerow]').forEach(function (node, i) {
      var v = node.querySelector('[data-rs2-sharesign]');
      if (v && rows[i]) v.textContent = rows[i][1];
    });
    renderDynamics();
    set('[data-rs2-focuspromise]', tx(PROMISE[s.focus || 'self']));
    var ph = $('[data-rs2-qtext]');
    if (ph) {
      ph.placeholder = tr('questionPlaceholder', {}, 'What would you like to understand about your result?');
      if (ph.value !== s.qText) ph.value = s.qText;
    }
    $all('[data-rs2-qpick]').forEach(function (btn) {
      var on = btn.textContent === s.qPick;
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
      btn.style.borderColor = on ? '#7A2423' : 'rgba(25,23,20,0.18)';
      btn.style.background = on ? '#7A2423' : 'transparent';
      btn.style.color = on ? '#FBF6EC' : '#3A342C';
    });
    renderQMeta();
    var attached = [
      [tx('Sun'), localPlacement(sunName(c))], [tx('Moon'), localPlacement(moonName(c))], [tx('Rising'), c.rising ? localSign(c.rising) : tx('Not calculated')],
      [tx('Birth time'), s.timeConf === 'exact' ? tx('Exact') : s.timeConf === 'approx' ? tx('Approximate') : tx('Unknown')],
      ['Focus', focusLabel()],
      [tx('Your question'), s.qPick || (s.qText.trim() ? tx('Written') : tx('Not added yet'))]
    ];
    $all('[data-rs2-attached] [data-rs2-att]').forEach(function (node, i) {
      if (attached[i]) node.textContent = attached[i][1];
    });
    renderPackages();
    renderXsell();
    renderSticky();
  }
  function renderQMeta() {
    var hint = $('[data-rs2-qhint]');
    if (hint) hint.textContent = s.qText.trim() ? tr('questionReady', {}, 'Your question will be included in your reading.') : tr('questionOptional', {}, 'Optional — ask about your result, or leave this blank.');
    var field = $('[data-rs2-qtext]');
    if (field) field.removeAttribute('aria-invalid');
    var error = $('[data-rs2-qerror]');
    if (error) { error.hidden = true; error.textContent = ''; }
    var count = $('[data-rs2-qcount]');
    if (count) {
      count.textContent = s.qText.length + ' / 700';
      count.style.color = s.qText.length > 640 ? '#7A2423' : '#5C554A';
    }
    var cta = $('[data-rs2-qcta]');
    if (cta) cta.textContent = (s.qPick || s.qText.trim()) ? tx('Attach my question and continue') : tx('Skip this and choose my reading');
    var note = $('[data-rs2-qctanote]');
    if (note) note.textContent = (s.qPick || s.qText.trim())
      ? tx('Your question stays attached through checkout. You can still edit it here.')
      : tx('A question is optional, but it makes the reading noticeably more specific.');
  }
  function renderSynthesis() {
    var syn = synthesisTexts();
    var set = function (sel, value) { var el = $(sel); if (el) el.textContent = value; };
    set('[data-rs2-synthesis]', syn.synthesis);
    set('[data-rs2-synthnote]', syn.note);
  }
  function renderDynamics() {
    var c = s.chart;
    var moonKey = c.moon.ambiguous ? c.moon.startSign : c.moon.sign;
    var sunKey = c.sun.ambiguous ? c.sun.startSign : c.sun.sign;
    var sun = signMeta(sunKey), moon = signMeta(moonKey), rising = c.rising ? signMeta(c.rising) : null;
    function relation(a, b) {
      if (a === b) return 'aligned';
      if ((a === 'Fire' && b === 'Air') || (a === 'Air' && b === 'Fire') || (a === 'Earth' && b === 'Water') || (a === 'Water' && b === 'Earth')) return 'supportive';
      if ((a === 'Fire' && b === 'Water') || (a === 'Water' && b === 'Fire') || (a === 'Earth' && b === 'Air') || (a === 'Air' && b === 'Earth')) return 'tension';
      return 'mixed';
    }
    function pairText(a, b, firstNeed, secondNeed) {
      var mode = relation(a[1], b[1]);
      if (mode === 'aligned') return tr('dynamicAligned', { element: localElement(a[1]), first: tx(firstNeed), second: tx(secondNeed) }, 'These two share the {element} element, so they usually agree on pace and priorities: {first} supports {second}.');
      if (mode === 'supportive') return tr('dynamicSupportive', { first: tx(firstNeed), second: tx(secondNeed) }, 'These placements support each other: {first} gives direction to {second}, so their differences can work as a team.');
      if (mode === 'tension') return tr('dynamicTension', { first: tx(firstNeed), second: tx(secondNeed) }, 'These placements use different instincts: {first} can pull against {second}. The useful question is which one the moment actually needs.');
      return tr('dynamicMixed', { first: tx(firstNeed), second: tx(secondNeed) }, 'These placements mix two different strengths: {first} and {second}. They work best when each is given a clear role.');
    }
    var bodies = [
      (c.sun.ambiguous || c.moon.ambiguous)
        ? tr('dynamicDateAmbiguous', { sun: localPlacement(sunName(c)), moon: localPlacement(moonName(c)) }, 'Without a birth time, the Sun or Moon changed signs that day. Your core pair is {sun} with {moon}; either option is carried honestly into the reading.')
        : pairText(sun, moon, sun[2], moon[3]),
      rising ? pairText(moon, rising, moon[3], rising[4]) : tr('dynamicNoRisingMoon', {}, 'Without a birth time we can describe what your Moon needs, but not the first impression you present before that need is met.'),
      rising ? pairText(sun, rising, sun[2], rising[4]) : tr('unknownScope', {}, 'Birth time unknown: this reading uses your Sun and Moon only. No Rising sign is inferred.')
    ];
    $all('[data-rs2-dynbody]').forEach(function (node, i) { node.textContent = bodies[i] || ''; });
    $all('[data-rs2-dynamic]').forEach(function (node, i) { node.hidden = !c.rising && i > 0; });
    var alt = $('[data-rs2-triangle]');
    if (alt) alt.setAttribute('aria-label', tr('triangleAlt', { sun: localPlacement(sunName(c)), moon: localPlacement(moonName(c)), rising: c.rising ? localSign(c.rising) : tx('not calculated') }, 'Triangle diagram: Sun {sun} at the top, Moon {moon} bottom left, Rising {rising} bottom right, meeting at your core pattern.'));
  }
  function renderCarousel() {
    if ($('.rs2-v3')) return;
    var isWide = wide();
    var wrap = $('[data-rs2-cards]');
    if (wrap) {
      wrap.style.display = isWide ? 'grid' : 'flex';
      wrap.style.overflowX = isWide ? 'visible' : 'auto';
    }
    $all('[data-rs2-cardcol]').forEach(function (node) {
      node.style.width = isWide ? '100%' : (mid() ? '58vw' : '78vw');
      node.style.flex = isWide ? '' : 'none';
    });
    var nav = $('[data-rs2-cardnav]');
    if (nav) nav.style.display = isWide ? 'none' : 'flex';
    $all('[data-rs2-carddot]').forEach(function (dot, i) {
      dot.style.background = i === s.card ? '#D8A45F' : 'rgba(241,230,210,0.3)';
    });
  }
  function renderPackages() {
    var unknown = s.timeConf === 'unknown';
    var fkey = s.focus || 'self';
    var unknownScope = $('[data-rs2-unknownscope]');
    if (unknownScope) unknownScope.hidden = !unknown;
    var packageNote = $('[data-rs2-pkgnote]');
    if (packageNote) packageNote.hidden = unknown;
    var questionField = $('[data-rs2-qtext]');
    if (questionField) questionField.readOnly = s.checkoutBusy;
    var set = function (sel, value) { var el = $(sel); if (el) el.textContent = value; };
    set('[data-rs2-producttitle]', unknown ? tx('Personalized Sun & Moon Core Reading') : tx('Personalized Sun, Moon & Rising Reading'));
    set('[data-rs2-pkgnote]', unknown
      ? tr('unknownScope', {}, 'Birth time unknown: this reading uses your Sun and Moon only. No Rising sign is inferred.')
      : tr('twoPackageNote', {}, 'Both readings use your calculated placements and your question. Choose how much guidance you want.'));
    var visiblePackages = ['pattern', 'blueprint'];
    var visiblePrices = visiblePackages.map(pricingForPackage).filter(function (price) { return !!price; });
    var bridgeReady = visiblePrices.length === visiblePackages.length && visiblePackages.every(packagePriceReady);
    if (bridgeReady) {
      visiblePrices.sort(function (a, b) { return a.priceMinor - b.priceMinor; });
      set('[data-rs2-bridgeprices]', uiText('readingsFrom', { min: visiblePrices[0].formattedPrice, max: visiblePrices[visiblePrices.length - 1].formattedPrice }));
    } else {
      set('[data-rs2-bridgeprices]', s.pricing.status === 'loading' ? uiCopy('priceChecking') : uiCopy('priceUnavailable'));
    }
    set('[data-rs2-bridgenote]', unknown
      ? tx('The free synthesis below explains your Sun and Moon. A personalized reading applies their pattern to the situation you selected.')
      : tx('The free synthesis below explains what each placement wants. A personalized reading explains how the three work together in the area you selected.'));
    var blueprint = $('[data-rs2-pkg="blueprint"]');
    if (blueprint) blueprint.style.display = 'flex';
    var patternDyn = $('[data-rs2-pattern-dyn]');
    if (patternDyn) patternDyn.textContent = unknown ? tx('Sun–Moon dynamic in depth') : tx('Sun–Moon, Moon–Rising and Sun–Rising dynamics');
    visiblePackages.forEach(function (id) {
      var card = $('[data-rs2-pkg="' + id + '"]');
      if (!card) return;
      var fb = (FOCUS_BULLET[fkey] || {})[id];
      var lead = card.querySelector('[data-rs2-focusbullet]');
      if (lead) lead.textContent = unknown
        ? tr('twoPlacementFocus', {}, 'How your Sun and Moon shape the question you selected')
        : tx(fb || '');
      var on = s.pkg === id;
      card.classList.toggle('rs2-pk-sel', on);
      card.style.border = on ? '2px solid #7A2423' : (id === 'pattern' ? '1.5px solid rgba(25,23,20,0.42)' : '1px solid rgba(25,23,20,0.14)');
      card.style.boxShadow = (on || id === 'pattern') ? '0 1px 2px rgba(25,23,20,0.04),0 14px 40px rgba(25,23,20,0.1)' : 'none';
      var cta = card.querySelector('[data-rs2-pkgcta]');
      var priceLabel = card.querySelector('[data-rs2-price]');
      var quote = pricingForPackage(id);
      if (priceLabel) priceLabel.textContent = packagePriceReady(id) ? quote.formattedPrice : '—';
      if (cta) {
        var price = pricingForPackage(id);
        var ready = packagePriceReady(id);
        var retry = canRetryPrices(id);
        var actions = { focused: uiCopy('focusedAction'), pattern: uiCopy('patternAction'), blueprint: uiCopy('blueprintAction') };
        cta.textContent = s.checkoutBusy && on
          ? uiCopy('openingCheckout')
          : ready
            ? actions[id] + ' — ' + price.formattedPrice
            : s.pricing.status === 'loading'
              ? uiCopy('priceChecking')
              : retry ? uiCopy('retryPrices') : uiCopy('priceUnavailable');
        cta.disabled = s.checkoutBusy || s.pricing.status === 'loading' || (!ready && !retry);
        cta.setAttribute('aria-disabled', String(cta.disabled));
        if (s.pricing.status === 'loading') cta.setAttribute('aria-busy', 'true');
        else cta.removeAttribute('aria-busy');
        cta.setAttribute('aria-pressed', on ? 'true' : 'false');
        cta.style.background = on ? '#7A2423' : (id === 'pattern' ? '#191714' : 'transparent');
        cta.style.color = (on || id === 'pattern') ? '#FBF6EC' : '#191714';
        cta.style.border = (on || id === 'pattern') ? '0' : '1px solid rgba(25,23,20,0.25)';
        cta.style.opacity = cta.disabled ? '0.62' : '1';
        cta.style.cursor = cta.disabled ? 'wait' : 'pointer';
      }
    });
    renderSticky();
  }
  function renderXsell() {
    var unknown = s.timeConf === 'unknown';
    var wrap = $('[data-rs2-xsell]');
    if (!wrap) return;
    wrap.style.display = s.pkg ? 'flex' : 'none';
    if (!s.pkg) return;
    var x = unknown ? ['How to Find Your Birth Time', 'Your birth time is missing, so the natural next step is finding it: the Rising sign depends on it. Check your birth certificate or hospital record first.', '#faq'] : XSELL[s.focus || 'self'];
    var set = function (sel, value) { var el = wrap.querySelector(sel); if (el) el.textContent = value; };
    set('[data-rs2-xsellname]', tx(x[0]));
    set('[data-rs2-xsellnote]', tx(x[1]));
    var link = wrap.querySelector('[data-rs2-xselllink]');
    if (link) link.setAttribute('href', localizedPath(x[2]));
  }
  function renderSticky() {
    var bar = $('[data-rs2-sticky]');
    if (!bar) return;
    var on = s.stage === 'result';
    bar.style.display = on ? 'block' : 'none';
    document.body.classList.toggle('rs2-sticky-on', on);
    if (!on) return;
    var names = { pattern: tx('Pattern Map'), blueprint: tx('Alignment Blueprint') };
    var sel = s.pkg;
    var set = function (selr, value) { var el = $(selr); if (el) el.textContent = value; };
    set('[data-rs2-stickytitle]', sel ? tr('packageSelected', { name: names[sel] }, '{name} selected') : tx('Your Big Three is ready'));
    set('[data-rs2-stickysub]', tr('questionOptional', {}, 'Optional — ask about your result, or leave this blank.'));
    var selBtn = $('[data-rs2-stickybuy]');
    var idleBtn = $('[data-rs2-stickyidle]');
    if (selBtn) {
      selBtn.style.display = sel ? 'flex' : 'none';
      if (sel) {
        var ready = packagePriceReady(sel);
        var retry = canRetryPrices(sel);
        var price = pricingForPackage(sel);
        selBtn.textContent = s.checkoutBusy
          ? uiCopy('openingCheckout')
          : ready
            ? tr('continueWith', { name: names[sel], price: price.formattedPrice }, 'Continue with {name} — {price}')
            : s.pricing.status === 'loading'
              ? uiCopy('priceChecking')
              : retry ? uiCopy('retryPrices') : uiCopy('priceUnavailable');
        selBtn.disabled = s.checkoutBusy || s.pricing.status === 'loading' || (!ready && !retry);
        selBtn.setAttribute('aria-disabled', String(selBtn.disabled));
        if (s.pricing.status === 'loading') selBtn.setAttribute('aria-busy', 'true');
        else selBtn.removeAttribute('aria-busy');
        selBtn.style.opacity = selBtn.disabled ? '0.62' : '1';
        selBtn.style.cursor = selBtn.disabled ? 'wait' : 'pointer';
      }
    }
    if (idleBtn) idleBtn.style.display = sel ? 'none' : 'flex';
    set('[data-rs2-stickyfine]', sel ? tx('One-time purchase · Secure checkout · Digital delivery') : tx('Free result saved · No account required'));
  }
  function renderDrawer() {
    var overlay = $('[data-rs2-drawerwrap]');
    if (overlay) overlay.style.display = s.drawer ? 'flex' : 'none';
    if (s.drawer && overlay && !modalOpen) {
      modalOpen = true;
      modalBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      modalReturnFocus = document.activeElement;
      modalInert = [];
      var branch = overlay;
      while (branch && branch.parentElement) {
        Array.prototype.forEach.call(branch.parentElement.children, function (node) {
          if (node !== branch && !/^(SCRIPT|STYLE|LINK)$/.test(node.tagName)) {
            modalInert.push({ node: node, inert: node.inert });
            node.inert = true;
          }
        });
        branch = branch.parentElement;
        if (branch === document.body) break;
      }
      var close = overlay.querySelector('button[data-rs2-act="drawerclose"]');
      if (close) close.focus({ preventScroll: true });
    } else if (!s.drawer && modalOpen) {
      modalOpen = false;
      document.body.style.overflow = modalBodyOverflow;
      modalInert.forEach(function (item) { item.node.inert = item.inert; });
      modalInert = [];
      if (modalReturnFocus && modalReturnFocus.isConnected) modalReturnFocus.focus({ preventScroll: true });
      modalReturnFocus = null;
    }
    $all('[data-rs2-sampletab]').forEach(function (tab) {
      var on = tab.getAttribute('data-rs2-sampletab') === s.sample;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
      tab.style.border = on ? '0' : '1px solid rgba(25,23,20,0.2)';
      tab.style.background = on ? '#191714' : 'transparent';
      tab.style.color = on ? '#FBF6EC' : '#191714';
    });
    $all('[data-rs2-samplepane]').forEach(function (pane) {
      pane.style.display = pane.getAttribute('data-rs2-samplepane') === s.sample ? 'grid' : 'none';
    });
  }

  /* ------------ flow ------------ */
  function goStep(n) {
    s.step = Math.max(1, Math.min(3, n));
    live(tr('stepLive', { step: s.step }, 'Step {step} of 3'));
    track('rs2_step', { step: s.step });
    renderWizard();
    var heading = $('[data-rs2-step="' + s.step + '"] h2');
    if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll: true }); }
  }
  function next() {
    if (s.step === 1) {
      if (!s.month || !s.day || !s.year) { s.dateErr = tx('Please complete month, day and year.'); renderWizard(); return; }
      var dt = new Date(parseInt(s.year, 10), parseInt(s.month, 10) - 1, parseInt(s.day, 10));
      if (dt.getDate() !== parseInt(s.day, 10)) { s.dateErr = tx('That day does not exist in the month you selected.'); renderWizard(); return; }
      if (dt > new Date()) { s.dateErr = tx('Birth dates in the future can’t be calculated.'); renderWizard(); return; }
      s.dateErr = '';
      goStep(2);
      return;
    }
    if (s.step === 2) {
      if (!s.timeConf) { live(tx('Please choose one birth time option.')); return; }
      if (!validTime()) { s.timeError = tr('timeRequired', {}, 'Enter your birth hour and minute, or choose “I don’t know”.'); renderWizard(); live(s.timeError); return; }
      goStep(3);
    }
  }
  function calculate() {
    if (!validDate()) { s.dateErr = tx('Please complete month, day and year.'); goStep(1); return; }
    if (!validTime()) { s.timeError = tr('timeRequired', {}, 'Enter your birth hour and minute, or choose “I don’t know”.'); goStep(2); return; }
    if (!s.place) { s.placeErr = tx('Select your birthplace from the list so we can match its time zone.'); renderWizard(); return; }
    if (!window.Astronomy) { s.placeErr = tx('The astronomy engine is still loading. Please try again in a moment.'); renderWizard(); return; }
    cancelPendingResult();
    s.stage = 'calc';
    s.calcPhase = 0;
    s.placeErr = '';
    s.timeError = '';
    live(tx('Calculating your Big Three'));
    track('rs2_calc', { timeConf: s.timeConf });
    renderWizard();
    clearInterval(t2);
    t2 = setInterval(function () { s.calcPhase = (s.calcPhase + 1) % 3; renderWizard(); }, 260);
    clearTimeout(t1);
    t1 = setTimeout(function () {
      clearInterval(t2);
      var chart = null;
      try { chart = computeChart(); } catch (err) {
        var reason = String(err && err.message);
        s.stage = 'input';
        s.chart = null;
        s.server = null;
        s.placeErr = '';
        s.dateErr = '';
        s.timeError = '';
        var focusSelector = '';
        if (reason === 'nonexistent_local_time') {
          s.step = 2;
          s.timeError = uiCopy('nonexistentLocalTime');
          focusSelector = '[data-rs2-hour]';
        } else if (reason === 'ambiguous_local_time') {
          s.step = 2;
          s.timeError = uiCopy('ambiguousLocalTime');
          focusSelector = '[data-rs2-timeconf="unknown"]';
        } else if (reason === 'nonexistent_local_date') {
          s.step = 1;
          s.dateErr = uiCopy('nonexistentLocalDate');
          focusSelector = '[data-rs2-month]';
        } else {
          s.step = 3;
          s.placeErr = reason === 'timezone'
            ? tx('We could not resolve that city’s historical time zone. Try a nearby larger city.')
            : tx('The astronomy engine could not complete the calculation. Please try again.');
          focusSelector = '[data-rs2-placequery]';
        }
        try {
          if (window.DeckauraDeepReading && typeof window.DeckauraDeepReading.hide === 'function') window.DeckauraDeepReading.hide();
          if (window.DeckauraDeepReading && typeof window.DeckauraDeepReading.setCheckoutPending === 'function') window.DeckauraDeepReading.setCheckoutPending(false);
        } catch (_) {}
        live(s.timeError || s.dateErr || s.placeErr);
        track('rs2_engine_fallback', { reason: reason.slice(0, 40) });
        renderWizard();
        setTimeout(function () { var target = $(focusSelector); if (target && typeof target.focus === 'function') target.focus(); }, 0);
        return;
      }
      s.chart = chart;
      s.server = null;
      s.stage = 'result';
      s.readingId = 'rs2-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
      s.pkg = null;
      s.checkoutBusy = false;
      s.pricing = blankPricing('loading', '');
      railReadingId = '';
      save();
      live(tx('Your Big Three result is ready.'));
      track('rs2_result', { timeConf: s.timeConf, rising: chart.rising ? 1 : 0 });
      renderWizard();
      try { window.scrollTo({ top: 0, behavior: 'auto' }); } catch (_) {}
      fetchSynthesis();
      enableRail();
    }, 900);
  }
  function startOver() {
    if (s.checkoutBusy) return;
    cancelPendingResult();
    s.drawer = false; renderDrawer();
    s.stage = 'input'; s.step = 1; s.focus = 'self';
    s.month = ''; s.day = ''; s.year = ''; s.dateErr = '';
    s.timeConf = null; s.hour = ''; s.minute = ''; s.mer = 'AM'; s.timeError = '';
    s.placeQuery = ''; s.place = null; s.placeTouched = false; s.placeErr = '';
    s.chart = null; s.server = null; s.qPick = null; s.qText = ''; s.pkg = null; s.card = 0;
    s.checkoutBusy = false; s.pricing = blankPricing('loading', ''); railReadingId = '';
    try { localStorage.removeItem(KEY); } catch (_) {}
    live(tx('Your birth details were cleared. Starting over.'));
    track('rs2_startover', {});
    renderWizard();
    try { window.scrollTo({ top: 0, behavior: 'auto' }); } catch (_) {}
  }
  function share() {
    var c = s.chart;
    if (!c) return;
    var txt = tr('shareText', {
      sun: localPlacement(sunName(c)), moon: localPlacement(moonName(c)),
      rising: c.rising ? localSign(c.rising) : tx('Rising not calculated'),
      url: 'https://deckaura.com' + PAGE
    }, 'My Big Three — {sun} Sun, {moon} Moon, {rising}. Calculated at {url}');
    var done = function () {
      var btn = $('[data-rs2-sharecta]');
      if (btn) btn.textContent = tx('Copied to your clipboard');
      live(tx('Result copied to your clipboard.'));
      track('rs2_share', {});
      clearTimeout(t3);
      t3 = setTimeout(function () { if (btn) btn.textContent = tx('Copy my Big Three'); }, 2400);
    };
    var failed = function () { live(tr('clipboardFailed', {}, 'Copy did not work. Select and copy the result text instead.')); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(done, failed);
    else failed();
  }
  function localizedPath(path) {
    if (!/^\/(pages|policies|cart)(\/|$)/.test(path)) return path;
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    return root.replace(/\/$/, '') + path;
  }
  function cancelPendingResult() {
    clearTimeout(t1); clearInterval(t2); clearTimeout(railTimer);
    synthesisEpoch += 1;
    if (synthesisAbort) synthesisAbort.abort();
    synthesisAbort = null; s.fetching = false; railReadingId = ''; railDeadline = 0;
    checkoutStatus('');
    var api = window.DeckauraDeepReading;
    if (api && typeof api.hide === 'function' && !s.checkoutBusy) api.hide();
  }
  function scrollToId(id) {
    var el = document.getElementById(id);
    if (!el) return;
    try { window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - 78, behavior: 'smooth' }); } catch (_) {}
  }

  /* ------------ events ------------ */
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    if (s.checkoutBusy && t.closest('[data-rs2-act],[data-rs2-pkgcta],[data-rs2-card-rising],[data-rs2-focus]')) return;
    var missingRising = t.closest('[data-rs2-card-rising]');
    if (missingRising && s.chart && !s.chart.rising) {
      s.stage = 'input';
      cancelPendingResult();
      s.step = 2;
      live(uiCopy('editBirthTime'));
      renderWizard();
      try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (_) {}
      return;
    }
    var pick = t.closest('[data-rs2-placepick]');
    if (pick) { pickPlace(parseInt(pick.getAttribute('data-rs2-placepick'), 10)); return; }
    var focusBtn = t.closest('[data-rs2-focus]');
    if (focusBtn) { s.focus = focusBtn.getAttribute('data-rs2-focus'); save(); renderWizard(); return; }
    var timeBtn = t.closest('[data-rs2-timeconf]');
    if (timeBtn) { s.timeConf = timeBtn.getAttribute('data-rs2-timeconf'); s.timeError = ''; save(); renderWizard(); return; }
    var qpick = t.closest('[data-rs2-qpick]');
    if (qpick) { s.qPick = qpick.textContent; save(); track('rs2_qpick', {}); renderResult(); return; }
    var pkgBtn = t.closest('[data-rs2-pkgcta]');
    if (pkgBtn) {
      if (!validateQuestion()) return;
      var pcard = pkgBtn.closest('[data-rs2-pkg]');
      var requestedPkg = pcard.getAttribute('data-rs2-pkg');
      syncPricingFromRail();
      if (!packagePriceReady(requestedPkg)) {
        if (canRetryPrices(requestedPkg)) retryMarketPrices(requestedPkg);
        else checkoutStatus(uiCopy('priceUnavailableHelp'), 'err');
        return;
      }
      s.pkg = requestedPkg;
      save();
      track('rs2_pkg', { pkg: s.pkg });
      renderPackages();
      renderXsell();
      enableRail();
      startCheckout('package-card');
      return;
    }
    var tab = t.closest('[data-rs2-sampletab]');
    if (tab) { s.sample = tab.getAttribute('data-rs2-sampletab'); renderDrawer(); return; }
    var faqBtn = t.closest('[data-rs2-faq]');
    if (faqBtn) {
      var open = faqBtn.getAttribute('aria-expanded') === 'true';
      faqBtn.setAttribute('aria-expanded', open ? 'false' : 'true');
      var body = faqBtn.nextElementSibling;
      if (body) body.style.display = open ? 'none' : 'block';
      var arrow = faqBtn.querySelector('[data-rs2-faqarrow]');
      if (arrow) arrow.style.transform = open ? 'rotate(45deg)' : 'rotate(-135deg)';
      track('rs2_faq', {});
      return;
    }
    var act = t.closest('[data-rs2-act]');
    if (!act) return;
    var kind = act.getAttribute('data-rs2-act');
    if (kind === 'next') next();
    else if (kind === 'back') goStep(Math.max(1, s.step - 1));
    else if (kind === 'calculate') calculate();
    else if (kind === 'edit') { cancelPendingResult(); s.stage = 'input'; s.step = 1; live(tx('Editing birth details')); renderWizard(); try { window.scrollTo({ top: 0 }); } catch (_) {} }
    else if (kind === 'startover') startOver();
    else if (kind === 'share') share();
    else if (kind === 'placeclear') { s.place = null; s.placeQuery = ''; save(); renderWizard(); }
    else if (kind === 'sheetclose') { s.sheet = false; renderWizard(); }
    else if (kind === 'draweropen') { s.drawer = true; track('rs2_sample', {}); renderDrawer(); }
    else if (kind === 'drawerclose') { s.drawer = false; renderDrawer(); }
    else if (kind === 'fulldetails') { ev.preventDefault(); var details = $('#rs2-full-result'); if (details) { details.open = true; scrollToId('rs2-full-result'); } }
    else if (kind === 'delivery') {
      var body2 = $('[data-rs2-deliverybody]');
      var open2 = act.getAttribute('aria-expanded') === 'true';
      act.setAttribute('aria-expanded', open2 ? 'false' : 'true');
      if (body2) body2.style.display = open2 ? 'none' : 'block';
      var arr = act.querySelector('span[aria-hidden]');
      if (arr) arr.style.transform = open2 ? 'rotate(45deg)' : 'rotate(-135deg)';
    }
    else if (kind === 'prevcard') { s.card = Math.max(0, s.card - 1); scrollCards(); }
    else if (kind === 'nextcard') { s.card = Math.min(2, s.card + 1); scrollCards(); }
    else if (kind === 'topackages') { scrollToId('offer'); var question = $('[data-rs2-qtext]'); if (question) question.focus({ preventScroll: true }); }
    else if (kind === 'checkout') startCheckout('sticky');
  });
  document.addEventListener('keydown', function (ev) {
    if (s.drawer) {
      var overlay = $('[data-rs2-drawerwrap]');
      if (ev.key === 'Escape') { ev.preventDefault(); s.drawer = false; renderDrawer(); return; }
      if (ev.key === 'Tab' && overlay) {
        var focusable = Array.prototype.filter.call(overlay.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex="0"]'), function (node) { return node.getClientRects().length > 0; });
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (first && ((!ev.shiftKey && (document.activeElement === last || !overlay.contains(document.activeElement))) || (ev.shiftKey && (document.activeElement === first || !overlay.contains(document.activeElement))))) {
          ev.preventDefault(); (ev.shiftKey ? last : first).focus();
        }
      }
      var sampleTab = ev.target && ev.target.closest && ev.target.closest('[data-rs2-sampletab]');
      if (sampleTab && /^(ArrowLeft|ArrowRight|Home|End)$/.test(ev.key)) {
        ev.preventDefault();
        var tabs = $all('[data-rs2-sampletab]'), at = tabs.indexOf(sampleTab);
        var index = ev.key === 'Home' ? 0 : ev.key === 'End' ? tabs.length - 1 : (at + (ev.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        s.sample = tabs[index].getAttribute('data-rs2-sampletab'); renderDrawer(); tabs[index].focus();
      }
    }
    if (ev.key !== 'Enter' && ev.key !== ' ') return;
    var risingCard = ev.target && ev.target.closest && ev.target.closest('[data-rs2-card-rising][role="button"]');
    if (!risingCard || !s.chart || s.chart.rising) return;
    ev.preventDefault();
    risingCard.click();
  });
  function scrollCards() {
    renderCarousel();
    var wrap = $('[data-rs2-cards]');
    if (!wrap) return;
    var first = wrap.children[0];
    var stepW = first ? first.offsetWidth + 16 : wrap.clientWidth * 0.62;
    try { wrap.scrollTo({ left: s.card * stepW, behavior: 'smooth' }); } catch (_) {}
  }
  document.addEventListener('input', function (ev) {
    var t = ev.target;
    if (!t || !t.hasAttribute) return;
    if (t.hasAttribute('data-rs2-placequery') || t.hasAttribute('data-rs2-sheetquery')) {
      s.placeQuery = t.value;
      s.place = null;
      s.placeTouched = true;
      s.placeErr = '';
      s.timeError = '';
      renderWizard();
      searchCity(t.value);
      return;
    }
    if (t.hasAttribute('data-rs2-qtext')) { if (s.checkoutBusy) { t.value = s.qText; return; } s.qText = t.value; s.qPick = null; save(); checkoutStatus(''); renderQMeta(); renderSticky(); return; }
  });
  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (!t || !t.hasAttribute) return;
    ['month', 'day', 'year', 'hour', 'minute'].forEach(function (k) {
      if (t.hasAttribute('data-rs2-' + k)) { s[k] = t.value; s.timeError = ''; if (k === 'month' || k === 'day' || k === 'year') s.dateErr = ''; save(); renderWizard(); }
    });
  });
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var am = t.closest('[data-rs2-am]');
    if (am) { s.mer = 'AM'; s.timeError = ''; save(); renderWizard(); return; }
    var pm = t.closest('[data-rs2-pm]');
    if (pm) { s.mer = 'PM'; s.timeError = ''; save(); renderWizard(); }
  });
  window.addEventListener('resize', function () { renderCarousel(); });
  document.addEventListener('deckaura:rs2-rail-ready', enableRail);
  document.addEventListener('DOMContentLoaded', enableRail);
  window.addEventListener('pageshow', function (event) {
    if (event.persisted && !s.checkoutBusy && s.stage === 'result') {
      railReadingId = ''; enableRail();
    }
  });

  /* ------------ init ------------ */
  try { $all('.rs2-scope').forEach(function (node) { I18N.apply(node); }); } catch (_) {}
  try {
    var saved = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (saved && saved.savedAt && (Date.now() - Number(saved.savedAt) > SAVE_TTL || Number(saved.savedAt) > Date.now() + 60000)) {
      localStorage.removeItem(KEY); saved = null;
    }
    if (saved && saved.stage === 'result' && saved.month && saved.day && saved.year && /^(exact|approx|unknown)$/.test(saved.timeConf) && validPlace(saved.place)) {
      s.focus = FOCI.some(function (item) { return item[0] === saved.focus; }) ? saved.focus : 'self';
      s.month = String(saved.month); s.day = String(saved.day); s.year = String(saved.year);
      s.timeConf = saved.timeConf;
      var canonicalTime = typeof saved.time24 === 'string' && /^(?:[01]\d|2[0-3]):[0-5]\d$/.test(saved.time24) ? saved.time24 : '';
      if (!canonicalTime && saved.version !== 3 && /^\d{1,2}$/.test(String(saved.hour)) && /^\d{1,2}$/.test(String(saved.minute))) {
        var oldHour = Number(saved.hour), oldMinute = Number(saved.minute);
        if (oldMinute >= 0 && oldMinute <= 59 && oldHour >= (saved.clock24 ? 0 : 1) && oldHour <= (saved.clock24 ? 23 : 12)) {
          canonicalTime = pad2(saved.clock24 ? oldHour : oldHour % 12 + (saved.mer === 'PM' ? 12 : 0)) + ':' + pad2(oldMinute);
        }
      }
      if (canonicalTime && s.timeConf !== 'unknown') {
        var restoredHour = Number(canonicalTime.slice(0, 2));
        s.hour = CLOCK_24 ? pad2(restoredHour) : String(restoredHour % 12 || 12);
        s.minute = canonicalTime.slice(3); s.mer = restoredHour >= 12 ? 'PM' : 'AM';
      }
      s.place = saved.place;
      s.placeQuery = saved.place.label || '';
      s.qPick = null;
      s.qText = String(saved.qText || '').slice(0, 700);
      if (saved.pkg === 'focused') s.pkg = 'pattern';
      else if (saved.pkg && RAIL_TIERS[saved.pkg]) s.pkg = saved.pkg;
      s.readingId = String(saved.readingId || '').slice(0, 80) || ('rs2-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7));
      var tries = 0;
      var restore = function () {
        tries += 1;
        if (window.Astronomy) {
          try {
            s.chart = computeChart();
            s.stage = 'result';
            s.server = saved.server && saved.server.key === serverKey() ? saved.server : null;
            renderWizard();
            fetchSynthesis();
            enableRail();
            save();
            return;
          } catch (_) {
            s.stage = 'input'; s.chart = null;
            s.step = validDate() ? 2 : 1;
            if (s.step === 2) s.timeError = tr('timeRequired', {}, 'Enter your birth hour and minute, or choose “I don’t know”.');
            renderWizard(); return;
          }
        }
        if (tries < 20) { setTimeout(restore, 350); return; }
        renderWizard();
      };
      restore();
    } else {
      renderWizard();
    }
  } catch (_) { renderWizard(); }
})();
